'use strict';

import React, { Component, useDebugValue, useRef } from 'react';
import { render } from 'react-dom';
import { AgGridReact } from '@ag-grid-community/react';
import { ClientSideRowModelModule } from '@ag-grid-community/client-side-row-model';
import { RowGroupingModule } from '@ag-grid-enterprise/row-grouping';
import { MenuModule } from '@ag-grid-enterprise/menu';
// import Consignmentforceclose from '../m';
import DrawMap from '../common/drawmap';
import CommentActions from "../layouts/commentsComponent";
import ForceCloseSideBar from "./forceclosuresidebarcomponent";
import { AllModules, GridOptionsWrapper } from '@ag-grid-enterprise/all-modules';
import { ColumnsToolPanelModule } from '@ag-grid-enterprise/column-tool-panel';
import { FiltersToolPanelModule } from '@ag-grid-enterprise/filter-tool-panel';
import { SetFilterModule } from '@ag-grid-enterprise/set-filter';
import MarkDeliver from "../layouts/markDeliveredButton.js";
import '@ag-grid-community/core/dist/styles/ag-grid.css';
import "@ag-grid-enterprise/all-modules/dist/styles/ag-theme-balham.css";
import ConsignmentActions from '../manage/ConsignmentActionsComponent';
import CountUp from 'react-countup';
import SweetAlert from 'react-bootstrap-sweetalert';
import CSVFileValidator from 'csv-file-validator';
import Consignmentforceclose from '../manage/consignmentforceclose';
import UpdateButton from "./updatelmstates";
import * as Datetime from 'react-datetime';
import 'react-datetime/css/react-datetime.css';
import CellGraphComponent from './cellGraphComponent';
import $ from 'jquery';
import ColumnGroup from './columngroupComponent';
import { getDDMMYYYY, getHyphenYYYYMMDD, getHyphenDDMMMYYYYHHMM, getHyphenDDMMMYYYY, getHyphenYYYYMMDDHHMMSS, getHyphenDDMMYYYYHHMMSS, getDDMMYYYYHHMMSS, getYYYYMMDD, getYYYYMMDDHHMMSS, getCellValue, getCellValueByPrefix, isSameIgnoreCase } from '../common/utils';
import Highcharts from 'highcharts/highstock';
import HighchartsReact from 'highcharts-react-official';
import { HardwareDesktopWindows } from 'material-ui/svg-icons';
import FullCalendar from '@fullcalendar/react'
import dayGridPlugin from '@fullcalendar/daygrid'
import interactionPlugin from '@fullcalendar/interaction'
import timeGridPlugin from "@fullcalendar/timegrid";
import { verifyext, verifycsvdata } from "../common/verifyext";
import { Edit, Trash } from 'lucide-react';
import AddEditController from './addEditController.js';
import XLSX from "xlsx/dist/xlsx.full.min.js";
import { LoadingPortContext, resolvePageAccess } from '../../context/LoadingPortContext';
// const $ = window.$;
window.jQuery = $;
window.$ = $;
var redirectURL = require('../redirectURL');
var moment = require('moment');
var filecontent = "";
var googleAnalytics = require("../common/googleanalytics");
var CELL_DIMENSION_SIZE = 90;




export default class LmFreights extends Component {
    static contextType = LoadingPortContext;

    constructor(props, context) {
        super(props, context);
        this._lastLoadingPortCode = context ? context.loading_port_code : null;
        this.state = {
            modules: AllModules,
            defaultColDef: {
                sortable: true,
                filter: true,
                // editable: true,
            },
            eventAction: null,
            show: false,
            frameworkComponents: {
                consignmentforceclose: Consignmentforceclose,
                consignmentActions: ConsignmentActions,
                UpdateButton: UpdateButton,
                MarkDeliver: MarkDeliver,
                commentActions: CommentActions,
                actionRenderer: this.ActionRenderer
            },
            modified_by: "",
            basicTitle: '',
            reasonforceclose: "",
            bulkslide: "",
            file: "",
            uploadFile: "",
            basicType: "default",
            loadshow: 'show-n',
            forceCloseRowNode: "",
            forceclosedata: "",
            csvcontent: "",
            sliderForceCloseTranslate: "",
            overly: '',
            rowData: [],
            bulkslide: false,
            showDiv: "",
            uploadDivWidth: "",
            mapinfo: "",
            dealer: "",
            sliderCommentTranslate: "",
            commentsRowData: "",
            consignment_code: "",
            sliderRouteTranslate: "",
            maptruckno: "",
            routeTruck: "",
            rownode: "",
            googelRoutes: "",
            file: "",
            rowSelection: 'multiple',
            sliderForceCloseTranslate: "",
            maptruckno: "",
            rowModelhighchartoptionsType: 'enterprise',
            rowGroupPanelShow: 'always',
            statusBar: {
                statusPanels: [
                    {
                        statusPanel: "agTotalAndFilteredRowCountComponent",
                        align: "left"
                    },
                    {
                        statusPanel: "agTotalRowCountComponent",
                        align: "center"
                    },
                    { statusPanel: "agFilteredRowCountComponent" },
                    { statusPanel: "agSelectedRowCountComponent" },
                    { statusPanel: "agAggregationComponent" }
                ]
            },
            paginationPageSize: 200,
            geofencelist: [],
            geoFenceData: "",
            sideBar: {
                toolPanels: [
                    {
                        id: "columns",
                        labelDefault: "Columns",
                        labelKey: "columns",
                        iconKey: "columns",
                        toolPanel: "agColumnsToolPanel"
                    },
                    {
                        id: "filters",
                        labelDefault: "Filters",
                        labelKey: "filters",
                        iconKey: "filter",
                        toolPanel: "agFiltersToolPanel"
                    }
                ]
            },
            animateRows: true,
            dept_code: "",
            pagetitle: "",
            markDeliverRowNode: "",
            markDeliverData: "",
            sliderMarkDeliverTranslate: "",
            csvData: 0,
            overly: "show-n",
            loadshow: "show-n",
            holidayEvents: [],
            showCalendar: "show-m",
            showGridData: "show-m",
            vehicleCap: [],
            statesList: [],
            rowIds: [],
            freight_type: 1,
            comp_code: "",
            lpNames: [],
            loading_port_code: "", selectedRows: [],
            tripFreightrowData: [], actTab: 2, courierData: [], transporterList: [], zoneArray: [],
            controller: {
                open: false
            }, clubbingChargesData: [], errors: [], validData: [],
            cityList: [],
            //components : {datepicker:getDatePicker()}
        }
        this.changeFileHandler = this.changeFileHandler.bind(this);
        this.uploadBulkFormHandler = this.uploadBulkFormHandler.bind(this);
        this.onCellClicked = this.onCellClicked.bind(this);
        this.checkFileData = this.checkFileData.bind(this);
        this.fileInputRef = React.createRef();
        this.gridRef = React.createRef();
        this.validateExcelData = this.validateExcelData.bind(this);
        this.handleFileChange = this.handleFileChange.bind(this);
    }
    // fileInputRef = useRef(null);
    componentDidMount() {
        // this.setState({
        //     loadshow: 'show-m',
        //     overly: 'show-m',
        // })
        loadDateTimeScript();
        this.pageAccess();

        redirectURL.post("/lmconsignees/getLmStates").then((response) => {
            var states = response.data;
            var statesList = [];
            if (states.length > 0) {
                states.map((item) => {
                    statesList.push(item.state)
                })
            }
            this.setState({
                statesList: statesList,
            })
        }).catch((e) => {
            console.log(e);
        })
        // this.setState({
        //     loadshow: 'show-n',
        //     overly: 'show-n',
        // })
    }

    async pageAccess() {
        this.setState({
            loadshow: 'show-m',
            overly: 'show-m',
        })
        var currentUrl = this.props.match.path;
        var resolved = await resolvePageAccess(currentUrl, this.context);
        if (!resolved) {
            // No access (already alerted+redirected), empty port list, or a logged request error.
            this.setState({ loadshow: 'show-n', overly: 'show-n' });
            return;
        }
        this._lastLoadingPortCode = resolved.loading_port_code;
        this.setState({
            pageAccess: resolved.pageAccess,
            loading_port_code: resolved.loading_port_code,
            comp_code: resolved.comp_code,
            lpNames: resolved.lpNames,
            loadshow: 'show-n',
            overly: 'show-n',
        });
        await this.onLoadPageData();
    }

    async onLoadPageData() {
        var loading_port_code = this.state.loading_port_code;

        redirectURL.post("/lmconsignees/getLoadingPlantDetails", {
            selectedPlant: loading_port_code
        }).then(async (response) => {
            var lpDetails = response.data;
            console.log(lpDetails, "lpDetails")
            if (lpDetails.length > 0) {
                this.setState({
                    freight_type: lpDetails[0].freight_type
                })
            }
            var freight_type = lpDetails[0].freight_type;
            var params = {
                loading_port_code: loading_port_code,
                // freight_type: freight_type
            }
            console.log(params, "params")
            redirectURL.post("/lmconsignees/getLmFreights", params).then((response) => {
                console.log(response.data);
                this.setState({
                    rowData: response.data,
                    loadshow: 'show-n',
                    overly: 'show-n',
                })
            }).catch((e) => {
                console.log(e);
            })
            await redirectURL.post("/lmconsignees/getCityNameList", { loading_port_code: loading_port_code, status: 1 }).then((response) => {
                var cities = response.data;
                // console.log(cities)
                // var cityList = [];
                // if (cities.length > 0) {
                //     cities.map((item) => {
                //         cityList.push(item)
                //     })
                // }
                this.setState({
                    cityList: cities,
                })
            }).catch((e) => {
                console.log(e);
            })
        }).catch((e) => {
            console.log(e);
        })
        var lpparams = {
            loading_port_code: loading_port_code,
            status: 1, hub_vehicle: 0
        }
        redirectURL.post("/lmconsignees/getVehicleDetails", lpparams).then((response) => {
            var results = response.data.records;
            var vehicleCap = []
            if (results.length > 0) {
                results.map((item) => {
                    vehicleCap.push(item)
                })
            }
            vehicleCap.push("Courier")
            //console.log(vehicleCap,"vehicleCap")
            this.setState({
                vehicleCap: vehicleCap,
                vehicleData: response.data.allRecords
            })

        }).catch((e) => {
            console.log(e);
        })
    }

    onGridReady = params => {
        this.gridApi = params.api;
        //console.log("Grid is: ", params);
        this.gridColumnApi = params.columnApi;
    };
    onGridState = () => {
        //console.log(this.gridApi);

        /*Get  Current Columns State and Store in this.colState */
        this.colState = this.gridColumnApi.getColumnState();

        /*Get Current RowGroup Columns State and Store in this.rowGroupState */
        this.rowGroupState = this.gridColumnApi.getRowGroupColumns();

        /*Get Current Pivot Columns State and Store in this.pivotColumns, 
        * User should enable the Pivot mode.*/
        this.pivotColumns = this.gridColumnApi.getPivotColumns();

        /*Get Current Filter State and Store in window.filterState */
        window.filterState = this.gridApi.getFilterModel();
        this.gridApi.setFilterModel(window.filterState);
    }



    closeAlert = () => {
        this.setState({
            show: false,
        });
    }

    onCellClicked(e) {
        if (e.colDef.field == "delete") {
            var rowId = e.data._id;
            console.log(e.data._id);
            var qry = {
                rowId: rowId,
                city: e.data.city,
                comp_code: this.state.comp_code,
                user_name: localStorage.getItem('username'),
                email: localStorage.getItem('email'),
                user_department: localStorage.getItem('lm_department'),
                staff_id: localStorage.getItem('staff_id'),
                designation: localStorage.getItem('designation'),
                user_role: localStorage.getItem('roles'),
            }
            //var confirm = confirm("Are You Sure! Do you want really delete?");
            if (window.confirm("Are You Sure! Do you want really delete?")) {
                redirectURL.post("/lmconsignees/deleteLmFreights", qry).then((response) => {
                    console.log(response.data);
                    if (response.data.message == "Success") {
                        this.setState({
                            basicTitle: "Deleted Successfully.",
                            basicType: "success",
                            show: true
                        })
                        //window.location.reload();
                        this.onLoadPageData();
                    }
                    else {
                        this.setState({
                            basicTitle: "Failed to Delete.",
                            basicType: "warning",
                            show: true
                        })
                    }
                }).catch((e) => {
                    console.log(e);
                })
            }
        }
    }

    onClickHideAll() {
        this.setState({
            loadshow: 'show-n',
            overly: 'show-n',
            bulkslide: false,
            errors: [],
            validData: [],
            fileName: "",
            controller: { open: false }
            // tripFreightrowData: []
        });

    }
    updateLmStates(data, type = "update") {
        this.setState({
            loadshow: 'show-m',
            overly: 'show-m'
        });
        var params = {};
        // console.log(params, this);
        if (data.length > 0) {
            var loading_port_code = this.state.loading_port_code;
            params["data"] = data;
            params["loading_port_code"] = loading_port_code;
            params['user_name'] = localStorage.getItem('username');
            params['email'] = localStorage.getItem('email');
            params['user_department'] = localStorage.getItem('lm_department');
            params['staff_id'] = localStorage.getItem('staff_id');
            params['designation'] = localStorage.getItem('designation');
            params['comp_code'] = this.state.comp_code;
            params['user_role'] = localStorage.getItem('roles');
            // params['freight_type'] = this.state.freight_type;
            redirectURL.post("/lmconsignees/savelmfreights", params).then((response) => {
                console.log(response);
                if (response.data.message == "Success") {
                    this.setState({
                        loadshow: 'show-n',
                        overly: 'show-n',
                        basicTitle: type === "add" ? "Added Successfully." : "Updated Successfully.",
                        basicType: "success",
                        show: true,
                        controller: {
                            open: false
                        }
                    })
                    //window.location.reload();
                    this.onLoadPageData();
                }
                else {
                    this.setState({
                        loadshow: 'show-n',
                        overly: 'show-n',
                        basicTitle: type === "add" ? "Failed to Add." : "Failed to update.",
                        basicType: "warning",
                        show: true,
                        controller: {
                            open: false
                        }
                    })
                }
            })
        }
        else if (params.freight_model !== undefined) {

            redirectURL.post("/lmconsignees/updateTripFreightConfigData", params).then((response) => {
                console.log(response);
                if (response.data.message == "success") {
                    this.setState({
                        loadshow: 'show-n',
                        overly: 'show-n',
                        basicTitle: type === "add" ? "Added Successfully." : "Updated Successfully.",
                        basicType: "success",
                        show: true
                    })
                }
                else {
                    this.setState({
                        loadshow: 'show-n',
                        overly: 'show-n',
                        basicTitle: type === "add" ? "Failed to Add." : "Failed to update.",
                        basicType: "warning",
                        show: true
                    })
                }
            })

        }
        else {
            this.setState({
                basicTitle: "Fields Should not be Empty.",
                basicType: "warning",
                show: true,
                loadshow: 'show-n',
                overly: 'show-n'
            })
        }
    }
    addNewRow() {
        var cityArray = this.state.cityList.map((each) => ({ label: each.city, value: each.city, state: each.state }));
        var stateArray = this.state.statesList.map((each) => ({ label: each, value: each }));
        var vehicleCapacityArray = this.state.vehicleCap.map((each) => ({ label: each, value: each }));
        var transporterArray = this.state.transporterList.map((each) => ({ label: each.transporter_name, value: each.transporter_code }));
        var zoneArray = [... new Set(this.state.zoneArray.map((each) => each.zone))].map((each) => ({ label: each, value: each }));
        // console.log([... new Set (this.state.zoneArray.map((each) => each.zone))])
        var freightTypeArray = [
            { label: "PER CMT", value: 1 },
            { label: "PER TRIP", value: 3 }
        ]
        var clubbingArray = [
            { label: "Intra-City", value: "intra_city" },
            { label: "Inter-City", value: "inter_city" }
        ]
        var freightResourceArray = [
            {
                id: 1,
                title: "City",
                field: "city",
                type: "dropdown",
                optionsArray: cityArray,
                errMsg: "Please select a city.",
                is_active: true,
                is_disabled: false,
                is_required: true
            },
            {
                id: 2,
                title: "State",
                field: "state",
                type: "dropdown",
                optionsArray: stateArray,
                errMsg: "Please select a state.",
                is_active: true,
                is_disabled: true,
                is_required: true
            },
            {
                id: 3,
                title: "Freight Rate ( ₹ )",
                field: "rate_cmt",
                type: "input",
                input_type: "number",
                errMsg: "Please enter the freight rate.",
                is_active: true,
                is_disabled: false,
                is_required: true
            },
            {
                id: 4,
                title: "Vehicle Type",
                field: "vehicle_cap",
                type: "dropdown",
                optionsArray: vehicleCapacityArray,
                errMsg: "Please select the vehicle type.",
                is_active: true,
                is_disabled: false,
                is_required: true
            },

            {
                id: 5,
                title: "Freight Type",
                field: "freight_type",
                type: "dropdown",
                optionsArray: freightTypeArray,
                errMsg: "Please select the Freight Type.",
                is_active: true,
                is_disabled: false,
                is_required: true
            },
        ];
        var courierResourceArray = [
            {
                id: 1,
                title: "Transporter",
                field: "transporter_code",
                type: "dropdown",
                optionsArray: transporterArray,
                errMsg: "Please select a Transporter.",
                is_active: true,
                is_disabled: false,
                is_required: true
            },
            {
                id: 2,
                title: "City",
                field: "city",
                type: "dropdown",
                optionsArray: cityArray,
                errMsg: "Please select a city.",
                is_active: true,
                is_disabled: false,
                is_required: true
            },
            {
                id: 3,
                title: "State",
                field: "state",
                type: "dropdown",
                optionsArray: stateArray,
                errMsg: "Please select a state.",
                is_active: true,
                is_disabled: true,
                is_required: true
            },
            {
                id: 4,
                title: "Freight Rate ( ₹ )",
                field: "rate_cmt",
                type: "input",
                input_type: "number",
                errMsg: "Please enter the freight rate.",
                is_active: true,
                is_disabled: false,
                is_required: true
            },
            // {
            //     id: 5,
            //     title: "Vehicle Capacity",
            //     field: "vehicle_cap",
            //     type: "dropdown",
            //     optionsArray: [{ label: "Courier", value: "Courier" }],
            //     errMsg: "Please select the vehicle capacity.",
            //     is_active: true,
            //     is_disabled: false,
            //     is_required: true
            // },

            {
                id: 6,
                title: "Freight Type",
                field: "freight_type",
                type: "dropdown",
                optionsArray: freightTypeArray,
                errMsg: "Please select the Freight Type.",
                is_active: true,
                is_disabled: false,
                is_required: true
            },
        ];
        var configResourceArray = [
            {
                id: 1,
                title: "Plant",
                field: "comp_short_name",
                type: "input",
                input_type: "text",
                errMsg: "Please select a Plant.",
                is_active: true,
                is_disabled: true,
                is_required: true
            },
            {
                id: 2,
                title: "Zone",
                field: "zone",
                type: "dropdown",
                optionsArray: zoneArray,
                errMsg: "Please select a zone.",
                is_active: true,
                is_disabled: false,
                is_required: true
            },
            {
                id: 5,
                title: "Freight Type",
                field: "freight_type",
                type: "dropdown",
                optionsArray: freightTypeArray,
                errMsg: "Please select the Freight Type.",
                is_active: true,
                is_disabled: false,
                is_required: true
            },
        ];

        var clubbingResourceArray = [
            {
                id: 1,
                title: "Vehicle Type",
                field: "vehicle_cap",
                type: "dropdown",
                optionsArray: vehicleCapacityArray.filter((each) => each.value != "Courier"),
                errMsg: "Please select the vehicle type.",
                is_active: true,
                is_disabled: false,
                is_required: true
            },
            // {
            //     id: 2,
            //     title: "Clubbing Type",
            //     field: "clubbing_type",
            //     type: "dropdown",
            //     optionsArray: clubbingArray,
            //     errMsg: "Please select a clubbing type.",
            //     is_active: true,
            //     is_disabled: false,
            //     is_required: true
            // },
            {
                id: 2,
                title: "Intra-City Charges ( ₹ )",
                field: "intra_city_charge",
                type: "input",
                input_type: "number",
                errMsg: "Please enter Intra City Charge.",
                is_active: true,
                is_disabled: false,
                is_required: true
            },
            {
                id: 3,
                title: "Inter-City Charges ( ₹ )",
                field: "inter_city_charge",
                type: "input",
                input_type: "number",
                errMsg: "Please enter Inter City Charge.",
                is_active: true,
                is_disabled: false,
                is_required: true
            },
            {
                id: 4,
                title: "Load Based Penalty ( ₹ )",
                field: "load_based_penalty",
                type: "input",
                input_type: "number",
                errMsg: "Please enter Load Based Penalty.",
                is_active: true,
                is_disabled: false,
                is_required: false
            },
            {
                id: 5,
                title: "Load Based Incentive ( ₹ )",
                field: "load_based_incentive",
                type: "input",
                input_type: "number",
                errMsg: "Please enter Load Based Incentive.",
                is_active: true,
                is_disabled: false,
                is_required: false
            },
            {
                id: 6,
                title: "Trip Penalty ( Min CMT )",
                field: "trip_penalty_min_cmt",
                type: "input",
                input_type: "number",
                errMsg: "Please enter Trip Penalty.",
                is_active: true,
                is_disabled: false,
                is_required: true
            },
            {
                id: 7,
                title: "Trip Incentive ( Min CMT )",
                field: "trip_incentive_min_cmt",
                type: "input",
                input_type: "number",
                errMsg: "Please enter Trip Incentive.",
                is_active: true,
                is_disabled: false,
                is_required: true
            }
        ];
        var titleLabel = this.state.actTab == 1 ? "Add New Config" : this.state.actTab == 2 ? "Add New Freight"
            : this.state.actTab == 3 ? "Add New Courier Freight" : this.state.actTab == 4 ? "Add New Clubbing charges"
                : this.state.actTab == 5 ? "Add New Air Courier Freight" : ""
        this.setState({
            controller: {
                open: true,
                title: titleLabel,
                btnType: "Add",
                formResourceArray: this.state.actTab == 1
                    ? configResourceArray : this.state.actTab == 2 ? freightResourceArray :
                        this.state.actTab == 3 ? courierResourceArray :
                            this.state.actTab == 4 ? clubbingResourceArray :
                                this.state.actTab == 5 ? courierResourceArray : [],

                type: "add",
                formData: this.state.actTab == 1 ?
                    {
                        loading_port_code: this.state.loading_port_code,
                        comp_short_name: this.state.lpNames.find((each) => each.loading_port_code == this.state.loading_port_code).loading_port
                    } : {}
            }
        })
    }
    showGrid() {
        this.setState({
            showCalendar: "show-n",
            showGridData: "show-m"
        })
    }
    onClickDataExport() {
        const fileNames = {
            1: "freight_config.xlsx",
            2: "freight.xlsx",
            3: "courier_freight.xlsx",
            4: "clubbing_charges.xlsx",
            5: "air_courier_freight.xlsx"
        };
        const api = this.gridRef.current.api;

        api.refreshCells();

        api.exportDataAsExcel({
            fileName: fileNames[this.state.actTab] || "freight.xlsx",
            processCellCallback: (params) => {

                if (params.column.getColId() === "rate_cmt") {
                    return params.value * 3;
                }

                return params.value;
            }
        });
    }
    onClickBulkDelete() {
        var rowIds = this.state.rowIds;
        console.log(rowIds, "rowIds")
        if (rowIds.length > 0) {
            var qry = {
                rowIds: rowIds,
                comp_code: this.state.comp_code,
                user_name: localStorage.getItem('username'),
                email: localStorage.getItem('email'),
                user_department: localStorage.getItem('lm_department'),
                staff_id: localStorage.getItem('staff_id'),
                designation: localStorage.getItem('designation'),
                user_role: localStorage.getItem('roles'),
            }
            //var confirm = confirm("Are You Sure! Do you want really delete?");
            if (window.confirm("Are You Sure! Do you want really delete?")) {
                redirectURL.post("/lmconsignees/deleteBulkLmFreights", qry).then((response) => {
                    console.log(response.data);
                    if (response.data.message == "Success") {
                        this.setState({
                            basicTitle: "Deleted Successfully.",
                            basicType: "success",
                            show: true,
                            rowIds: []
                        })
                        //window.location.reload();
                        this.onLoadPageData();
                    }
                    else {
                        this.setState({
                            basicTitle: "Failed to Delete.",
                            basicType: "warning",
                            show: true
                        })
                    }
                }).catch((e) => {
                    console.log(e);
                })
            }
        }
        else {
            this.setState({
                basicTitle: "Please select the Row(s) to continue.",
                basicType: "warning",
                show: true
            })
        }
    }
    showBulkUpload() {
        this.setState({
            overly: "show-m",
            bulkslide: true,
            errors: [],
            validData: [],
            fileName: ""
        })
    }
    resetUpload = () => {
        this.setState({
            bulkslide: '',
            overly: 'show-n',
            file: ''
        });
        document.getElementById("upform").reset();
    }
    changeFileHandler = async (e) => {
        var availableData = this.state.statesList
        var dt = '';
        const config = {
            headers: [
                // { 
                //     name: 'id',
                //     inputName: 'id',
                //     required: false,
                // },
                {
                    name: 'city',
                    inputName: 'city',
                    required: true,
                    requiredError: function (headerName, rowNumber, columnNumber) {
                        return `${headerName} is required in the ${rowNumber} row / ${columnNumber} column`
                    }
                },
                {
                    name: 'state',
                    inputName: 'state',
                    required: true,
                    requiredError: function (headerName, rowNumber, columnNumber) {
                        return `${headerName} is required in the ${rowNumber} row / ${columnNumber} column`
                    },
                    // validate: function (uploadedData) {
                    //     return isValidState(uploadedData, availableData);
                    // }
                },
                {
                    name: 'freight_rate',
                    inputName: 'freight_rate',
                    required: true,
                    requiredError: function (headerName, rowNumber, columnNumber) {
                        return `${headerName} is required in the ${rowNumber} row / ${columnNumber} column`
                    }
                },
                {
                    name: 'vehicle_capacity',
                    inputName: 'vehicle_capacity',
                    required: true,
                    requiredError: function (headerName, rowNumber, columnNumber) {
                        return `${headerName} is required in the ${rowNumber} row / ${columnNumber} column`
                    }
                },
            ]
        }
        var data = CSVFileValidator(e.target.files[0], config)
            .then((csvData) => {
                console.log(csvData)
                this.setState({
                    csvData: csvData.data
                });
                console.log(csvData.data);
            })
            .catch(err => { })
        // console.log("e.target.files[0]",e.target.result);

        var out = new Promise(function (reject, resolve) {
            var reader = new FileReader();
            reader.onload = async function (e) {
                var contents = await e.target.result;
                resolve(contents);
            };
            var tt = reader.readAsText(e.target.files[0]);
        });
        this.setState({
            file: e.target.files[0]
        });
        //this.checkFileData();
        //console.log("e.target.files[0].type ", e.target.files[0]);
        var check = verifyext(e.target.files[0].name);
        //console.log("Check ", check)
        if (check == true) {
            if (e.target.files[0].type == '' || e.target.files[0].type == 'text/csv' || e.target.files[0].type == 'application/vnd.ms-excel') {
                // console.log(fileData);
                // console.log(typeof(fileData))

            }
            else {
                e.target.value = null;
                this.setState({
                    uploadFile: '',
                    show: true,
                    basicType: 'danger',
                    basicTitle: 'Please upload file having extensions .csv only.',
                });
            }
        }
        else {
            e.target.value = null;
            this.setState({
                uploadFile: '',
                show: true,
                basicType: 'danger',
                basicTitle: 'Please upload file having extensions .csv only.',
            });
        }
    }

    checkFileData() {

        var vdata = verifycsvdata(JSON.stringify(this.state.csvData));
        //console.log("verifycsvdata ", vdata)
        if (vdata == 0) {
            this.setState({
                csvData: '',
                show: true,
                basicType: 'danger',
                basicTitle: 'File contains invalid data',
                uploadFile: '',
                file: ""
            });
        }
    }
    uploadBulkFormHandler(event) {
        event.preventDefault();
        var fileData = this.state.csvData;
        // Defining function to get unique values from an array

        // var uniqueData = fileData.filter(function(el, i, x) {
        //     return x.some(function(obj, j) {
        //         return obj.city === el.city && (x = j);
        //     }) && i == x;
        // });
        console.log(fileData, "fileData")
        var flag = 0;
        // console.log("JSON.stringify(this.state.csvData) ", JSON.stringify(this.state.csvData))
        var vdata = verifycsvdata(JSON.stringify(this.state.csvData));
        //console.log("verifycsvdata ", vdata)
        if (vdata == true) {
            this.setState({
                csvData: '',
                show: true,
                basicType: 'danger',
                basicTitle: 'File contains invalid data',
                uploadFile: '',
                file: ""
            });
        }
        else {
            if (flag == 0) {
                if (fileData.length > 0) {
                    this.setState({
                        overly: "show-m",
                        loadshow: "show-m",
                    })
                    var loading_port_code = this.state.loading_port_code;
                    var reqParams = {
                        csvData: fileData,
                        loading_port_code: loading_port_code
                    }
                    reqParams["loading_port_code"] = loading_port_code;
                    reqParams['user_name'] = localStorage.getItem('username');
                    reqParams['email'] = localStorage.getItem('email');
                    reqParams['staff_id'] = localStorage.getItem('staff_id');
                    reqParams['user_department'] = localStorage.getItem('lm_department');
                    reqParams['designation'] = localStorage.getItem('designation');
                    reqParams['comp_code'] = this.state.comp_code;
                    reqParams['user_role'] = localStorage.getItem('roles');
                    reqParams['freight_type'] = this.state.freight_type;
                    console.log("reqParams", reqParams)
                    redirectURL.post("/lmconsignees/savebulklmfreights", reqParams).then((response) => {
                        var resp = response.data.message;
                        console.log(resp)
                        this.setState({
                            basicTitle: resp,
                            basicType: "success",
                            show: true,
                            bulkslide: '',
                            loadshow: "show-n",
                            overly: 'show-n',
                        })
                        //window.location.reload();
                        this.onLoadPageData();
                    }).catch((e) => {
                        console.log(e);
                    })
                }
                else {
                    this.setState({
                        basicTitle: "Invalid File",
                        basicType: "warning",
                        show: true,
                    })
                }
                $('#upform')[0].reset();
            }
            else {
                $("#bulkUploadID").val();
                this.setState({
                    basicTitle: "Fields Should not be Empty",
                    basicType: "warning",
                    show: true,
                })
                $('#upform')[0].reset();
            }
        }
    };




    onSelectBulkPlants = (location) => {
        var plants = [];
        try {
            location.map(function (e) {
                plants.push(e.value);
            })
            console.log(plants);
            this.setState({
                plant_name: plants
            });
        }
        catch (e) {
            console.log(e);
        }

    }

    onRowSelection(event) {
        var rowIds = [];
        var rwCount = event.api.getSelectedNodes();
        rwCount.map((item) => {
            rowIds.push(item.data._id)
        });

        this.setState({
            rowIds: rowIds
        })
    }

    onChangeFreightType() {
        var freight_type = $("#freightType").val();
        if (freight_type != '') {
            var loading_port_code = this.state.loading_port_code;
            var params = {
                loading_port_code: loading_port_code,
                freight_type: freight_type
            }
            redirectURL.post("/lmconsignees/updateFreightType", params).then((response) => {
                this.setState({
                    freight_type: freight_type
                })
                this.onLoadPageData()
            }).catch((e) => {
                console.log(e);
            })
        }
    }
    componentDidUpdate() {
        if (this.context && this.context.loading_port_code !== this._lastLoadingPortCode) {
            this._lastLoadingPortCode = this.context.loading_port_code;
            this.onGlobalPortChange();
        }
    }
    onGlobalPortChange = () => {
        var selectedPlant = this.context.loading_port_code;
        if (!selectedPlant || !this.state.lpNames.some(each => each.loading_port_code == selectedPlant)) {
            // Not a valid port for this screen - keep this screen's own selection, don't refetch.
            return;
        }
        this.setState({
            loadshow: 'show-m',
            overly: 'show-m',
        })
        var params = {
            selectedPlant: selectedPlant,
        }
        redirectURL.post("/lmconsignees/getLoadingPlantDetails", params)
            .then((response) => {
                var res = response.data;
                this.setState({
                    loading_port_code: selectedPlant,
                    comp_code: res[0].comp_code,
                    loadshow: 'show-n',
                    overly: 'show-n',
                }, () => {
                    if (this.state.actTab == 1) {
                        this.getZoneList();
                        this.onClickGetTripFreightConfig();
                    } else if (this.state.actTab == 2) {
                        this.pageAccess();
                    } else if (this.state.actTab == 3) {
                        this.getCourierFreightData();
                    } else if (this.state.actTab == 4) {
                        this.getClubbingChargesData();
                    } else if (this.state.actTab == 5) {
                        this.getAirCourierFrieghtData();
                    }
                })
            })
            .catch(function (e) {
                console.log("Error ", e)
            })
    }

    onClickGetTripFreightConfig = () => {

        let params = {
            loading_port_code: this.state.loading_port_code,
            status: 1
        }
        redirectURL.post("/lmconsignees/getTripFreightConfigData", params)
            .then((response) => {
                var res = response.data;
                this.setState({
                    loadshow: 'show-n',
                    overly: 'show-n',
                    tripFreightrowData: res,
                    // bulkslide: "slider-translate-50p"
                })
            })
            .catch(function (e) {
                console.log("Error ", e)
            })
    }
    getZoneList = () => {

        let params = {
            loading_port_code: this.state.loading_port_code,
            status: 1
        }
        redirectURL.post("/lmconsignees/getLmSobZones", params)
            .then((response) => {
                var res = response.data;
                this.setState({
                    loadshow: 'show-n',
                    overly: 'show-n',
                    zoneArray: res,
                    // bulkslide: "slider-translate-50p"
                })
            })
            .catch(function (e) {
                console.log("Error ", e)
            })
    }


    handleEdit = (params) => {
        var cityArray = this.state.cityList.map((each) => ({ label: each.city, value: each.city, state: each.state }));
        var transporterArray = this.state.transporterList.map((each) => ({ label: each.transporter_name, value: each.transporter_code }));
        var stateArray = this.state.statesList.map((each) => ({ label: each, value: each }));
        var vehicleCapacityArray = this.state.vehicleCap.map((each) => ({ label: each, value: each }));
        var zoneArray = this.state.zoneArray.map((each) => ({ label: each.zone, value: each.zone }));
        var freightTypeArray = [
            { label: "PER CMT", value: 1 },
            { label: "PER TRIP", value: 3 }
        ]
        var clubbingArray = [
            { label: "Intra-City", value: "intra_city" },
            { label: "Inter-City", value: "inter_city" }
        ]
        var freightResourceArray = [
            {
                id: 1,
                title: "City",
                field: "city",
                type: "dropdown",
                optionsArray: cityArray,
                errMsg: "Please select a city.",
                is_active: true,
                is_disabled: true,
                is_required: true
            },
            {
                id: 2,
                title: "State",
                field: "state",
                type: "dropdown",
                optionsArray: stateArray,
                errMsg: "Please select a state.",
                is_active: true,
                is_disabled: true,
                is_required: true
            },
            {
                id: 3,
                title: "Freight Rate ( ₹ )",
                field: "rate_cmt",
                type: "input",
                input_type: "number",
                errMsg: "Please enter the freight rate.",
                is_active: true,
                is_disabled: false,
                is_required: true
            },
            {
                id: 4,
                title: "Vehicle Type",
                field: "vehicle_cap",
                type: "dropdown",
                optionsArray: vehicleCapacityArray,
                errMsg: "Please select the vehicle type.",
                is_active: true,
                is_disabled: true,
                is_required: true
            },
            {
                id: 5,
                title: "Freight Type",
                field: "freight_type",
                type: "dropdown",
                optionsArray: freightTypeArray,
                errMsg: "Please select the Freight Type.",
                is_active: true,
                is_disabled: true,
                is_required: true
            },
        ];
        var configResourceArray = [
            {
                id: 1,
                title: "Plant",
                field: "comp_short_name",
                type: "input",
                input_type: "text",
                errMsg: "Please select a Plant.",
                is_active: true,
                is_disabled: true,
                is_required: true
            },
            {
                id: 2,
                title: "Zone",
                field: "zone",
                type: "dropdown",
                optionsArray: zoneArray,
                errMsg: "Please select a zone.",
                is_active: true,
                is_disabled: true,
                is_required: true
            },
            {
                id: 5,
                title: "Freight Type",
                field: "freight_type",
                type: "dropdown",
                optionsArray: freightTypeArray,
                errMsg: "Please select the Freight Type.",
                is_active: true,
                is_disabled: false,
                is_required: true
            },
        ];
        var courierResourceArray = [
            {
                id: 1,
                title: "Transporter",
                field: "transporter_code",
                type: "dropdown",
                optionsArray: transporterArray,
                errMsg: "Please select a Transporter.",
                is_active: true,
                is_disabled: true,
                is_required: true
            },
            {
                id: 2,
                title: "City",
                field: "city",
                type: "dropdown",
                optionsArray: cityArray,
                errMsg: "Please select a city.",
                is_active: true,
                is_disabled: true,
                is_required: true
            },
            {
                id: 3,
                title: "State",
                field: "state",
                type: "dropdown",
                optionsArray: stateArray,
                errMsg: "Please select a state.",
                is_active: true,
                is_disabled: true,
                is_required: true
            },
            {
                id: 4,
                title: "Freight Rate ( ₹ )",
                field: "rate_cmt",
                type: "input",
                input_type: "number",
                errMsg: "Please enter the freight rate.",
                is_active: true,
                is_disabled: false,
                is_required: true
            },
            // {
            //     id: 5,
            //     title: "Vehicle Capacity",
            //     field: "vehicle_cap",
            //     type: "dropdown",
            //     optionsArray: [{ label: "Courier", value: "Courier" }],
            //     errMsg: "Please select the vehicle capacity.",
            //     is_active: true,
            //     is_disabled: true,
            //     is_required: true
            // },

            {
                id: 6,
                title: "Freight Type",
                field: "freight_type",
                type: "dropdown",
                optionsArray: freightTypeArray,
                errMsg: "Please select the Freight Type.",
                is_active: true,
                is_disabled: true,
                is_required: true
            },
        ];
        var clubbingResourceArray = [
            {
                id: 1,
                title: "Vehicle Type",
                field: "vehicle_cap",
                type: "dropdown",
                optionsArray: vehicleCapacityArray.filter((each) => each.value != "Courier"),
                errMsg: "Please select the vehicle type.",
                is_active: true,
                is_disabled: true,
                is_required: true
            },
            // {
            //     id: 2,
            //     title: "Clubbing Type",
            //     field: "clubbing_type",
            //     type: "dropdown",
            //     optionsArray: clubbingArray,
            //     errMsg: "Please select a clubbing type.",
            //     is_active: true,
            //     is_disabled: false,
            //     is_required: true
            // },

            {
                id: 2,
                title: "Intra-City Charges ( ₹ )",
                field: "intra_city_charge",
                type: "input",
                input_type: "number",
                errMsg: "Please enter Intra City Charge.",
                is_active: true,
                is_disabled: false,
                is_required: true
            },
            {
                id: 3,
                title: "Inter-City Charges ( ₹ )",
                field: "inter_city_charge",
                type: "input",
                input_type: "number",
                errMsg: "Please enter Inter City Charge.",
                is_active: true,
                is_disabled: false,
                is_required: true
            },
            {
                id: 4,
                title: "Load Based Penalty ( ₹ )",
                field: "load_based_penalty",
                type: "input",
                input_type: "number",
                errMsg: "Please enter Load Based Penalty.",
                is_active: true,
                is_disabled: false,
                is_required: false
            },
            {
                id: 5,
                title: "Load Based Incentive ( ₹ )",
                field: "load_based_incentive",
                type: "input",
                input_type: "number",
                errMsg: "Please enter Load Based Incentive.",
                is_active: true,
                is_disabled: false,
                is_required: false
            },
            {
                id: 6,
                title: "Trip Penalty ( Min CMT )",
                field: "trip_penalty_min_cmt",
                type: "input",
                input_type: "number",
                errMsg: "Please enter Trip Penalty.",
                is_active: true,
                is_disabled: false,
                is_required: true
            },
            {
                id: 7,
                title: "Trip Incentive ( Min CMT )",
                field: "trip_incentive_min_cmt",
                type: "input",
                input_type: "number",
                errMsg: "Please enter Trip Incentive.",
                is_active: true,
                is_disabled: false,
                is_required: true
            },
        ];
        var titleLabel = this.state.actTab == 1 ? "Edit Config" : this.state.actTab == 2 ? "Edit Freight" :
            this.state.actTab == 3 ? "Edit Courier Freight" : this.state.actTab == 4 ? "Edit Clubbing Charges" :
                this.state.actTab == 5 ? "Edit Air Courier Freight" : ""
        this.setState({
            controller: {
                open: true,
                title: titleLabel,
                btnType: "Update",
                formResourceArray: this.state.actTab == 1
                    ? configResourceArray : this.state.actTab == 2 ? freightResourceArray :
                        this.state.actTab == 3 ? courierResourceArray : this.state.actTab == 4 ? clubbingResourceArray :
                            this.state.actTab == 5 ? courierResourceArray : [],

                type: "update",
                formData: params.data || {}
            }
        })
    };

    handleDelete = async (params) => {
        if (this.state.actTab == 1) {
            this.setState({
                rowIds: [params.data._id]
            }, () => {
                this.onClickFreightConfigBulkDelete();
            })
        } else if (this.state.actTab == 3) {
            this.setState({
                rowIds: [params.data._id]
            }, () => {
                this.onClickCourierFreightBulkDelete();
            })
        }
        else if (this.state.actTab == 2) {
            this.setState({
                rowIds: [params.data._id]
            }, () => {
                this.onClickBulkDelete();
            })
        } else if (this.state.actTab == 4) {
            this.setState({
                rowIds: [params.data._id]
            }, () => {
                this.onClickClubbingBulkDelete();
            })
        } else if (this.state.actTab == 5) {
            this.setState({
                rowIds: [params.data._id]
            }, () => {
                this.onClickAirCourierFreightBulkDelete();
            })
        }
    };
    ActionRenderer = (props) => (
        <div className="d-flex justify-content-center align-items-center" style={{ gap: '6px', justifyContent: "center", width: "100%", height: "35px" }}>

            <Edit className="text-primary cursor-pointer ml-2"
                size={15} style={{ cursor: "pointer" }} onClick={() => { this.handleEdit(props) }} />
            <Trash className="text-danger cursor-pointer ml-2"
                size={15} style={{ cursor: "pointer" }} onClick={() => { this.handleDelete(props) }} />
        </div>
    );
    updateFreightTypeConfig = (object, type = "update") => {
        var params = {};
        var loading_port_code = this.state.loading_port_code;
        params["data"] = object;
        params["loading_port_code"] = loading_port_code;
        params['user_name'] = localStorage.getItem('username');
        params['email'] = localStorage.getItem('email');
        params['user_department'] = localStorage.getItem('lm_department');
        params['staff_id'] = localStorage.getItem('staff_id');
        params['designation'] = localStorage.getItem('designation');
        params['comp_code'] = this.state.comp_code;
        params['user_role'] = localStorage.getItem('roles');
        redirectURL.post("/lmconsignees/updateTripFreightConfigData", params).then((response) => {
            console.log(response);
            if (response.data.message == "Success") {
                this.onClickGetTripFreightConfig();
                this.setState({
                    loadshow: 'show-n',
                    overly: 'show-n',
                    controller: {
                        open: false
                    },
                    basicTitle: type === "add" ? "Added Successfully." : "Updated Successfully.",
                    basicType: "success",
                    show: true
                })
            }
            else {
                this.setState({
                    loadshow: 'show-n',
                    overly: 'show-n',
                    basicTitle: type === "add" ? "Failed to Add." : "Failed to update.",
                    basicType: "warning",
                    show: true
                })
            }
        })
    }
    onUpdateFreight = (object, type) => {
        console.log(object)
        this.setState({
            loadshow: 'show-m',
            overly: 'show-m',
        })
        if (this.state.actTab == 1) {
            var correctedObject = {
                ...object,
                freight_model: object.freight_type == 1 ? "PER_CMT" : object.freight_type == 3 ? "PER_TRIP" : "",
                status: 1
            }
            console.log(object, correctedObject)
            this.updateFreightTypeConfig([correctedObject], type)
        } else if (this.state.actTab == 2) {
            this.updateLmStates([object], type)
        } else if (this.state.actTab == 3) {
            // transporter_code alone doesn't always resolve (legacy rows saved
            // before transporter_code was consistently tracked, or a transporter
            // master entry that only differs by transporter_name casing) - fall
            // back to the same case-insensitive name match bulk upload uses, and
            // keep the row's existing values instead of crashing if neither matches.
            var transporter = this.state.transporterList.find((each) => each.transporter_code == object.transporter_code)
                || this.findTransporterByName(object.transporter_name);
            var correctedObject = {
                ...object,
                transporter_name: transporter ? transporter.transporter_name : object.transporter_name,
                transporter_code: transporter ? transporter.transporter_code : object.transporter_code,
                vehicle_cap: "Courier",
                status: 1,
                is_active: 1,
                // The form's rate_cmt input hands back a raw string — left
                // unconverted here, it saved straight into courierData and
                // crashed the grid's rate_cmt valueGetter's .toFixed(2)
                // call the next time this row rendered (strings don't have
                // toFixed). Matches the parseFloat(...) || 0 pattern
                // already used for tab 4's numeric fields below.
                rate_cmt: parseFloat(object.rate_cmt) || 0
            }
            this.updateLmCourirerFreight([correctedObject], type)
        } else if (this.state.actTab == 4) {
            var correctedObject = {
                ...object,
                loading_port_code: this.state.loading_port_code,
                status: 1,
                intra_city_charge: parseFloat(object.intra_city_charge) || 0,
                inter_city_charge: parseFloat(object.inter_city_charge) || 0,
                load_based_penalty: parseFloat(object.load_based_penalty) || 0,
                load_based_incentive: parseFloat(object.load_based_incentive) || 0,
                trip_penalty_min_cmt: parseFloat(object.trip_penalty_min_cmt) || 0,
                trip_incentive_min_cmt: parseFloat(object.trip_incentive_min_cmt) || 0
            }
            this.updateLmClubbingCharges([correctedObject], type)
        } else if (this.state.actTab == 5) {
            // Same code/name fallback as tab 3's courier branch above.
            var transporter = this.state.transporterList.find((each) => each.transporter_code == object.transporter_code)
                || this.findTransporterByName(object.transporter_name);
            var correctedObject = {
                ...object,
                transporter_name: transporter ? transporter.transporter_name : object.transporter_name,
                transporter_code: transporter ? transporter.transporter_code : object.transporter_code,
                vehicle_cap: "AIR COURIER",
                status: 1,
                is_active: 1,
                // Same missing conversion as tab 3's courier branch above —
                // this tab also renders through courierColumnwithDefs'
                // rate_cmt column (see columnObject's `5: courierColumnwithDefs`).
                rate_cmt: parseFloat(object.rate_cmt) || 0
            }
            this.updateLmAirCourirerFreight([correctedObject], type)
        }
    }

    getCourierFreightData = () => {
        var object = {
            loading_port_code: this.state.loading_port_code,
            status: 1
        }
        redirectURL.post("/lmconsignees/getCourierFreightData", object).then((response) => {
            // console.log(response);
            if (response.data.status == "success") {
                this.setState({
                    loadshow: 'show-n',
                    overly: 'show-n',
                    courierData: response.data.data
                })
            }
            else {
                this.setState({
                    loadshow: 'show-n',
                    overly: 'show-n'
                })
            }
        })
    }
    getAirCourierFrieghtData = () => {
        var object = {
            loading_port_code: this.state.loading_port_code,
            status: 1
        }
        redirectURL.post("/lmconsignees/getAirCourierFreightData", object).then((response) => {
            // console.log(response);
            if (response.data.status == "success") {
                this.setState({
                    loadshow: 'show-n',
                    overly: 'show-n',
                    airCourierData: response.data.data
                })
            }
            else {
                this.setState({
                    loadshow: 'show-n',
                    overly: 'show-n'
                })
            }
        })
    }
    getTranporterList = () => {
        var object = {
            loading_port_code: this.state.loading_port_code,
            // Surface Courier and Air Courier transporters are both saved under
            // data_type: 2 in lmtransporters.js - only air_courier_transporter tells
            // them apart, so data_type must stay 2 for both tabs here too.
            data_type: 2, air_courier_transporter: this.state.actTab === 5 ? 1 : 0,
            status: 1
        }
        redirectURL.post("/lmconsignees/prtUniqueTransportersListWithNames", object).then((response) => {
            console.log(response);
            if (response.status == "200") {
                this.setState({
                    transporterList: response.data.filter((each) => each.transporter_code)
                })
            }
            else {
                this.setState({
                    // loadshow: 'show-n',
                    // overly: 'show-n'
                })
            }
        })
    }

    onClickTab = (count) => {
        this.setState((prevState) => ({
            ...prevState, actTab: count, loadshow: 'show-m',
            overly: 'show-m',
        }), () => {
            if (count == 1) {
                this.getZoneList();
                this.onClickGetTripFreightConfig();
            } else if (count == 2) {
                this.onLoadPageData();
            } else if (count == 3) {
                this.getTranporterList();
                this.getCourierFreightData();
            } else if (count == 4) {
                // this.getTranporterList();
                this.getClubbingChargesData();
            } else if (count == 5) {
                this.getTranporterList();
                this.getAirCourierFrieghtData();
            }
        })
    }

    updateLmCourirerFreight = (data, type = "update") => {
        this.setState({
            loadshow: 'show-m',
            overly: 'show-m'
        });
        console.log(params)

        var params = {};
        var loading_port_code = this.state.loading_port_code;
        params["data"] = data;
        params["loading_port_code"] = loading_port_code;
        params['user_name'] = localStorage.getItem('username');
        params['email'] = localStorage.getItem('email');
        params['user_department'] = localStorage.getItem('lm_department');
        params['staff_id'] = localStorage.getItem('staff_id');
        params['designation'] = localStorage.getItem('designation');
        params['comp_code'] = this.state.comp_code;
        params['user_role'] = localStorage.getItem('roles');
        // params['freight_type'] = this.state.freight_type;
        redirectURL.post("/lmconsignees/savelmCourierfreights", params).then((response) => {
            console.log(response);
            if (response.data.message == "Success") {
                this.setState({
                    loadshow: 'show-n',
                    overly: 'show-n',
                    basicTitle: type === "add" ? "Added Successfully." : "Updated Successfully.",
                    basicType: "success",
                    show: true,
                    controller: {
                        open: false
                    }
                })
                //window.location.reload();
                this.getCourierFreightData();
            }
            else {
                this.setState({
                    loadshow: 'show-n',
                    overly: 'show-n',
                    basicTitle: type === "add" ? "Failed to Add." : "Failed to update.",
                    basicType: "warning",
                    show: true,
                    controller: {
                        open: false
                    }
                })
            }
        })

    }
    updateLmAirCourirerFreight = (data, type = "update") => {
        this.setState({
            loadshow: 'show-m',
            overly: 'show-m'
        });
        console.log(params)

        var params = {};
        var loading_port_code = this.state.loading_port_code;
        params["data"] = data;
        params["loading_port_code"] = loading_port_code;
        params['user_name'] = localStorage.getItem('username');
        params['email'] = localStorage.getItem('email');
        params['user_department'] = localStorage.getItem('lm_department');
        params['staff_id'] = localStorage.getItem('staff_id');
        params['designation'] = localStorage.getItem('designation');
        params['comp_code'] = this.state.comp_code;
        params['user_role'] = localStorage.getItem('roles');
        // params['freight_type'] = this.state.freight_type;
        redirectURL.post("/lmconsignees/savelmAirCourierfreights", params).then((response) => {
            console.log(response);
            if (response.data.message == "Success") {
                this.setState({
                    loadshow: 'show-n',
                    overly: 'show-n',
                    basicTitle: type === "add" ? "Added Successfully." : "Updated Successfully.",
                    basicType: "success",
                    show: true,
                    controller: {
                        open: false
                    }
                })
                //window.location.reload();
                this.getAirCourierFrieghtData();

            }
            else {
                this.setState({
                    loadshow: 'show-n',
                    overly: 'show-n',
                    basicTitle: type === "add" ? "Failed to Add." : "Failed to update.",
                    basicType: "warning",
                    show: true,
                    controller: {
                        open: false
                    }
                })
            }
        })

    }
    onClickCourierFreightBulkDelete = () => {
        var rowIds = this.state.rowIds;
        console.log(rowIds, "rowIds")
        if (rowIds.length > 0) {
            var qry = {
                rowIds: rowIds,
                comp_code: this.state.comp_code,
                user_name: localStorage.getItem('username'),
                email: localStorage.getItem('email'),
                user_department: localStorage.getItem('lm_department'),
                staff_id: localStorage.getItem('staff_id'),
                designation: localStorage.getItem('designation'),
                user_role: localStorage.getItem('roles'),
            }
            //var confirm = confirm("Are You Sure! Do you want really delete?");
            if (window.confirm("Are You Sure! Do you want really delete?")) {
                redirectURL.post("/lmconsignees/deleteBulkLmCourierFreights", qry).then((response) => {
                    console.log(response.data);
                    if (response.data.message == "Success") {
                        this.setState({
                            basicTitle: "Deleted Successfully.",
                            basicType: "success",
                            show: true, selectedRows: [],
                            rowIds: []
                        })
                        //window.location.reload();
                        this.getCourierFreightData();
                    }
                    else {
                        this.setState({
                            basicTitle: "Failed to Delete.",
                            basicType: "warning",
                            show: true
                        })
                    }
                }).catch((e) => {
                    console.log(e);
                })
            }
        }
        else {
            this.setState({
                basicTitle: "Please select the Row(s) to continue.",
                basicType: "warning",
                show: true
            })
        }
    }
    onClickAirCourierFreightBulkDelete = () => {
        var rowIds = this.state.rowIds;
        console.log(rowIds, "rowIds")
        if (rowIds.length > 0) {
            var qry = {
                rowIds: rowIds,
                comp_code: this.state.comp_code,
                user_name: localStorage.getItem('username'),
                email: localStorage.getItem('email'),
                user_department: localStorage.getItem('lm_department'),
                staff_id: localStorage.getItem('staff_id'),
                designation: localStorage.getItem('designation'),
                user_role: localStorage.getItem('roles'),
            }
            //var confirm = confirm("Are You Sure! Do you want really delete?");
            if (window.confirm("Are You Sure! Do you want really delete?")) {
                redirectURL.post("/lmconsignees/deleteBulkLmAirCourierFreights", qry).then((response) => {
                    console.log(response.data);
                    if (response.data.message == "Success") {
                        this.setState({
                            basicTitle: "Deleted Successfully.",
                            basicType: "success",
                            show: true, selectedRows: [],
                            rowIds: []
                        })
                        //window.location.reload();
                        this.getCourierFreightData();
                    }
                    else {
                        this.setState({
                            basicTitle: "Failed to Delete.",
                            basicType: "warning",
                            show: true
                        })
                    }
                }).catch((e) => {
                    console.log(e);
                })
            }
        }
        else {
            this.setState({
                basicTitle: "Please select the Row(s) to continue.",
                basicType: "warning",
                show: true
            })
        }
    }
    onClickFreightConfigBulkDelete = () => {
        var rowIds = this.state.rowIds;
        console.log(rowIds, "rowIds")
        if (rowIds.length > 0) {
            var qry = {
                rowIds: rowIds,
                comp_code: this.state.comp_code,
                user_name: localStorage.getItem('username'),
                email: localStorage.getItem('email'),
                user_department: localStorage.getItem('lm_department'),
                staff_id: localStorage.getItem('staff_id'),
                designation: localStorage.getItem('designation'),
                user_role: localStorage.getItem('roles'),
            }
            //var confirm = confirm("Are You Sure! Do you want really delete?");
            if (window.confirm("Are You Sure! Do you want really delete?")) {
                redirectURL.post("/lmconsignees/deleteBulkLmFreightConfig", qry).then((response) => {
                    console.log(response.data);
                    if (response.data.message == "Success") {
                        this.setState({
                            basicTitle: "Deleted Successfully.",
                            basicType: "success",
                            show: true,
                            rowIds: []
                        })
                        //window.location.reload();
                        this.onClickGetTripFreightConfig();
                    }
                    else {
                        this.setState({
                            basicTitle: "Failed to Delete.",
                            basicType: "warning",
                            show: true
                        })
                    }
                }).catch((e) => {
                    console.log(e);
                })
            }
        }
        else {
            this.setState({
                basicTitle: "Please select the Row(s) to continue.",
                basicType: "warning",
                show: true
            })
        }
    }
    getClubbingChargesData = () => {
        var object = {
            loading_port_code: this.state.loading_port_code,
            status: 1
        }
        redirectURL.post("/lmconsignees/getClubbingChargesData", object).then((response) => {
            // console.log(response);
            if (response.data.status == "success") {
                this.setState({
                    loadshow: 'show-n',
                    overly: 'show-n',
                    clubbingChargesData: response.data.data
                })
            }
            else {
                this.setState({
                    loadshow: 'show-n',
                    overly: 'show-n'
                })
            }
        })
        this.setState({
            loadshow: 'show-n',
            overly: 'show-n'
        })
    }
    updateLmClubbingCharges(object, type = "update") {
        this.setState({
            loadshow: 'show-m',
            overly: 'show-m'
        });
        var params = {};
        console.log(params, this);
        params["data"] = object;
        params['user_name'] = localStorage.getItem('username');
        params['email'] = localStorage.getItem('email');
        params['user_department'] = localStorage.getItem('lm_department');
        params['staff_id'] = localStorage.getItem('staff_id');
        params['designation'] = localStorage.getItem('designation');
        params['comp_code'] = this.state.comp_code;
        params['user_role'] = localStorage.getItem('roles');
        redirectURL.post("/lmconsignees/updateLmClubbingCharges", params).then((response) => {
            console.log(response);
            if (response.data.message == "Success") {
                this.setState({
                    loadshow: 'show-n',
                    overly: 'show-n',
                    basicTitle: type === "add" ? "Added Successfully." : "Updated Successfully.",
                    basicType: "success",
                    show: true,
                    controller: {
                        open: false
                    }
                })
                this.getClubbingChargesData();
            }
            else {
                this.setState({
                    loadshow: 'show-n',
                    overly: 'show-n',
                    basicTitle: type === "add" ? "Failed to Add." : "Failed to update.",
                    basicType: "warning",
                    show: true,
                    controller: {
                        open: false
                    }
                })
            }
        })
    }
    handleBulkDelete = async (params) => {
        if (this.state.actTab == 1) {
            this.setState({
                rowIds: params
            }, () => {
                this.onClickFreightConfigBulkDelete();
            })
        } else if (this.state.actTab == 3) {
            this.setState({
                rowIds: params
            }, () => {
                this.onClickCourierFreightBulkDelete();
            })
        }
        else if (this.state.actTab == 2) {
            this.setState({
                rowIds: params
            }, () => {
                this.onClickBulkDelete();
            })
        } else if (this.state.actTab == 4) {
            this.setState({
                rowIds: params
            }, () => {
                this.onClickClubbingBulkDelete();
            })
        } else if (this.state.actTab == 5) {
            this.setState({
                rowIds: params
            }, () => {
                this.onClickAirCourierFreightBulkDelete();
            })
        }
    };
    onClickClubbingBulkDelete = () => {
        var rowIds = this.state.rowIds;
        console.log(rowIds, "rowIds")
        if (rowIds.length > 0) {
            var qry = {
                rowIds: rowIds,
                comp_code: this.state.comp_code,
                user_name: localStorage.getItem('username'),
                email: localStorage.getItem('email'),
                user_department: localStorage.getItem('lm_department'),
                staff_id: localStorage.getItem('staff_id'),
                designation: localStorage.getItem('designation'),
                user_role: localStorage.getItem('roles'),
            }
            //var confirm = confirm("Are You Sure! Do you want really delete?");
            if (window.confirm("Are You Sure! Do you want really delete?")) {
                redirectURL.post("/lmconsignees/deleteBulkLmClubbingCharges", qry).then((response) => {
                    console.log(response.data);
                    if (response.data.message == "Success") {
                        this.setState({
                            basicTitle: "Deleted Successfully.",
                            basicType: "success",
                            show: true,
                            rowIds: []
                        })
                        //window.location.reload();
                        this.getClubbingChargesData();
                    }
                    else {
                        this.setState({
                            basicTitle: "Failed to Delete.",
                            basicType: "warning",
                            show: true
                        })
                    }
                }).catch((e) => {
                    console.log(e);
                })
            }
        }
        else {
            this.setState({
                basicTitle: "Please select the Row(s) to continue.",
                basicType: "warning",
                show: true
            })
        }
    }
    isValidNumber = (value) => {
        const str = String(value || "").trim();
        return str !== "" && /^-?\d+(\.\d+)?$/.test(str);
    };

    handleFileChange = (e) => {

        const file = e.target.files[0];
        e.target.value = ""; // reset immediately

        if (!file) return;
        this.setState({ fileName: file.name }); // store file name

        const reader = new FileReader();
        reader.readAsArrayBuffer(file);

        reader.onload = (event) => {

            const workbook = XLSX.read(
                new Uint8Array(event.target.result),
                { type: "array" }
            );

            const sheet = workbook.Sheets[workbook.SheetNames[0]];

            const data = XLSX.utils.sheet_to_json(sheet, { defval: "" });

            this.validateExcelData(data);
        };
    };
    // ================= VALIDATION =================
    validateExcelData = (data) => {

        let errorList = [];
        let cleanedData = [];
        console.log(data)


        if (this.state.actTab == 1) {
            data.forEach((row, index) => {

                const rowNumber = index + 2; // Excel row (header = 1)

                let zoneInput = String(getCellValue(row, "ZONE") || "").trim();

                let freight_model = getCellValue(row, "FREIGHT MODEL");
                let rowErrors = [];

                const zoneArray = [...new Set(this.state.zoneArray.map((each) => each.zone))];
                const matchedZone = zoneArray.find((each) => isSameIgnoreCase(each, zoneInput));
                let zone = matchedZone || zoneInput;
                if (!matchedZone) {
                    rowErrors.push(`Zone - "${zoneInput}" does not exist in available zones.`);
                }
                if (
                    !freight_model
                ) {
                    rowErrors.push(
                        `${freight_model} - Select Freight Model`
                    );
                }

                // ---- Collect Errors ----
                if (rowErrors.length > 0) {
                    errorList.push({
                        row: rowNumber,
                        errors: rowErrors
                    });
                } else {
                    cleanedData.push({
                        zone: zone,
                        freight_model: freight_model
                    });
                }
            });
        } else if (this.state.actTab == 2) {
            data.forEach((row, index) => {

                const rowNumber = index + 2; // Excel row (header = 1)

                let cityInput = String(getCellValue(row, "CITY") || "").trim();
                let stateInput = String(getCellValue(row, "STATE") || "").trim();
                let freight_rate = String(getCellValueByPrefix(row, "FREIGHT RATE") || "")
                let freight_type = String(getCellValue(row, "FREIGHT TYPE") || "").trim();
                let vehicle_capInput = String(getCellValue(row, "VEHICLE TYPE") || "").trim();
                let rowErrors = [];

                const matchedCity = this.state.cityList.find((each) => isSameIgnoreCase(each.city, cityInput));
                const matchedCityState = this.state.cityList.find((each) => isSameIgnoreCase(each.city, cityInput) && isSameIgnoreCase(each.state, stateInput));
                const vehicleCapArray = [...new Set(this.state.vehicleCap)];
                const matchedVehicleCap = vehicleCapArray.find((each) => isSameIgnoreCase(each, vehicle_capInput));
                const freight_type_normalized = freight_type.toUpperCase();

                let city = matchedCity ? matchedCity.city : cityInput;
                let state = matchedCityState ? matchedCityState.state : stateInput;
                let vehicle_cap = matchedVehicleCap || vehicle_capInput;

                if (!matchedCity) {
                    rowErrors.push(`City - "${cityInput}" does not exist in available cities.`);
                }
                if (!matchedCityState) {
                    rowErrors.push(`State - "${stateInput}" is not mapped to the given city.`);
                }
                if (!matchedVehicleCap) {
                    rowErrors.push(`Vehicle Type - "${vehicle_capInput}" does not exist in available vehicles.`);
                }
                if (!freight_type) {
                    rowErrors.push(
                        `${freight_type} - Select Freight Type`
                    );
                }
                if (!this.isValidNumber(freight_rate)) {
                    rowErrors.push(
                        `Freight Rate should be numeric (${freight_rate})`
                    );
                }

                // ---- Collect Errors ----
                if (rowErrors.length > 0) {
                    errorList.push({
                        row: rowNumber,
                        errors: rowErrors
                    });
                } else {
                    cleanedData.push({
                        city: city,
                        state: state,
                        vehicle_cap: vehicle_cap,
                        rate_cmt: parseFloat(freight_rate),
                        freight_type: freight_type_normalized == "PER CMT" ? 1 : freight_type_normalized == "PER TRIP" ? 3 : 0,

                    });
                }
            });
        } else if (this.state.actTab == 3) {
            data.forEach((row, index) => {

                const rowNumber = index + 2; // Excel row (header = 1)
                let transporter_name = String(getCellValue(row, "TRANSPORTER NAME") || "").trim()
                let cityInput = String(getCellValue(row, "CITY") || "").trim();
                let stateInput = String(getCellValue(row, "STATE") || "").trim();
                let freight_rate = String(getCellValueByPrefix(row, "FREIGHT RATE") || "")
                let freight_type = String(getCellValue(row, "FREIGHT TYPE") || "").trim();
                // let vehicle_cap = String(getCellValue(row, "VEHICLE CAPACITY") || "").trim()
                let rowErrors = [];

                var matchedTransporter = this.findTransporterByName(transporter_name);
                if (!matchedTransporter) {
                    rowErrors.push(`Transporter - "${transporter_name}" does not exist in available transporters.`);
                }
                const matchedCity = this.state.cityList.find((each) => isSameIgnoreCase(each.city, cityInput));
                const matchedCityState = this.state.cityList.find((each) => isSameIgnoreCase(each.city, cityInput) && isSameIgnoreCase(each.state, stateInput));
                const freight_type_normalized = freight_type.toUpperCase();

                let city = matchedCity ? matchedCity.city : cityInput;
                let state = matchedCityState ? matchedCityState.state : stateInput;

                if (!matchedCity) {
                    rowErrors.push(`City - "${cityInput}" does not exist in available cities.`);
                }
                if (!matchedCityState) {
                    rowErrors.push(`State - "${stateInput}" is not mapped to the given city.`);
                }
                // if (!this.checkVehicleCapIdentity(vehicle_cap)) {
                //     rowErrors.push(`Vehicle Capacity - "${vehicle_cap}" does not exist in available vehicles.`);
                // }
                if (!freight_type) {
                    rowErrors.push(
                        `${freight_type} - Select Freight Type`
                    );
                }
                if (!this.isValidNumber(freight_rate)) {
                    rowErrors.push(
                        `Freight Rate should be numeric (${freight_rate})`
                    );
                }

                // ---- Collect Errors ----
                if (rowErrors.length > 0) {
                    errorList.push({
                        row: rowNumber,
                        errors: rowErrors
                    });
                } else {
                    cleanedData.push({
                        city: city,
                        state: state,
                        vehicle_cap: "Courier",
                        rate_cmt: parseFloat(freight_rate),
                        freight_type: freight_type_normalized == "PER CMT" ? 1 : freight_type_normalized == "PER TRIP" ? 3 : 0,
                        // Saved with the transporter list's own casing, not whatever
                        // case the upload happened to use - see findTransporterByName.
                        transporter_name: matchedTransporter.transporter_name,
                        transporter_code: matchedTransporter.transporter_code
                    });
                }
            });
        } else if (this.state.actTab == 4) {
            data.forEach((row, index) => {

                const rowNumber = index + 2; // Excel row (header = 1)
                let vehicle_capInput = String(getCellValue(row, "VEHICLE TYPE") || "").trim();
                let intra_city_charge = getCellValueByPrefix(row, "INTRA-CITY CHARGE")
                let inter_city_charge = getCellValueByPrefix(row, "INTER-CITY CHARGE")
                let load_based_penalty = getCellValueByPrefix(row, "LOAD BASED PENALTY")
                let load_based_incentive = getCellValueByPrefix(row, "LOAD BASED INCENTIVE")
                let trip_penalty_min_cmt = getCellValue(row, "TRIP PENALTY ( Min CMT )")
                let trip_incentive_min_cmt = getCellValue(row, "TRIP INCENTIVE ( Min CMT )")
                let rowErrors = [];
                // console.log(clubbing_type)
                const vehicleCapArray = [...new Set(this.state.vehicleCap)];
                const matchedVehicleCap = vehicleCapArray.find((each) => isSameIgnoreCase(each, vehicle_capInput));
                let vehicle_cap = matchedVehicleCap || vehicle_capInput;
                if (!matchedVehicleCap) {
                    rowErrors.push(`Vehicle Type - "${vehicle_capInput}" does not exist in available vehicles.`);
                }
                // if (!clubbing_type) {
                //     rowErrors.push(
                //         `${clubbing_type} - Select Clubbing Type`
                //     );
                // }
                if (!this.isValidNumber(intra_city_charge)) {
                    rowErrors.push(
                        `Intra City Charge should be numeric - "${intra_city_charge}"`
                    );
                }
                if (!this.isValidNumber(inter_city_charge)) {
                    rowErrors.push(
                        `Inter City Charge should be numeric - "${inter_city_charge}"`
                    );
                }
                if (load_based_penalty && !this.isValidNumber(load_based_penalty)) {
                    rowErrors.push(
                        `Load Based Penalty should be numeric - "${load_based_penalty}"`
                    );
                }
                if (load_based_incentive && !this.isValidNumber(load_based_incentive)) {
                    rowErrors.push(
                        `Load Based Incentive should be numeric - "${load_based_incentive}"`
                    );
                }
                if (!this.isValidNumber(trip_penalty_min_cmt)) {
                    rowErrors.push(
                        `Trip Penalty should be numeric - "${trip_penalty_min_cmt}"`
                    );
                }
                if (!this.isValidNumber(trip_incentive_min_cmt)) {
                    rowErrors.push(
                        `Trip Incentive should be numeric - "${trip_incentive_min_cmt}"`
                    );
                }

                // ---- Collect Errors ----
                if (rowErrors.length > 0) {
                    errorList.push({
                        row: rowNumber,
                        errors: rowErrors
                    });
                } else {
                    cleanedData.push({
                        // clubbing_type: clubbing_type.toLowerCase().replace("-", "_"),
                        intra_city_charge: parseFloat(intra_city_charge || 0),
                        inter_city_charge: parseFloat(inter_city_charge || 0),
                        vehicle_cap: vehicle_cap,
                        load_based_penalty: parseFloat(load_based_penalty || 0),
                        load_based_incentive: parseFloat(load_based_incentive || 0),
                        trip_penalty_min_cmt: parseFloat(trip_penalty_min_cmt || 0),
                        trip_incentive_min_cmt: parseFloat(trip_incentive_min_cmt || 0),
                    });
                }
            });
        } else if (this.state.actTab == 5) {
            data.forEach((row, index) => {

                const rowNumber = index + 2; // Excel row (header = 1)
                let transporter_name = String(getCellValue(row, "TRANSPORTER NAME") || "").trim()
                let cityInput = String(getCellValue(row, "CITY") || "").trim();
                let stateInput = String(getCellValue(row, "STATE") || "").trim();
                let freight_rate = String(getCellValueByPrefix(row, "FREIGHT RATE") || "")
                let freight_type = String(getCellValue(row, "FREIGHT TYPE") || "").trim();
                // let vehicle_cap = String(getCellValue(row, "VEHICLE CAPACITY") || "").trim()
                let rowErrors = [];

                var matchedTransporter = this.findTransporterByName(transporter_name);
                if (!matchedTransporter) {
                    rowErrors.push(`Transporter - "${transporter_name}" does not exist in available transporters.`);
                }
                const matchedCity = this.state.cityList.find((each) => isSameIgnoreCase(each.city, cityInput));
                const matchedCityState = this.state.cityList.find((each) => isSameIgnoreCase(each.city, cityInput) && isSameIgnoreCase(each.state, stateInput));
                const freight_type_normalized = freight_type.toUpperCase();

                let city = matchedCity ? matchedCity.city : cityInput;
                let state = matchedCityState ? matchedCityState.state : stateInput;

                if (!matchedCity) {
                    rowErrors.push(`City - "${cityInput}" does not exist in available cities.`);
                }
                if (!matchedCityState) {
                    rowErrors.push(`State - "${stateInput}" is not mapped to the given city.`);
                }
                // if (!this.checkVehicleCapIdentity(vehicle_cap)) {
                //     rowErrors.push(`Vehicle Capacity - "${vehicle_cap}" does not exist in available vehicles.`);
                // }
                if (!freight_type) {
                    rowErrors.push(
                        `${freight_type} - Select Freight Type`
                    );
                }
                if (!this.isValidNumber(freight_rate)) {
                    rowErrors.push(
                        `Freight Rate should be numeric (${freight_rate})`
                    );
                }

                // ---- Collect Errors ----
                if (rowErrors.length > 0) {
                    errorList.push({
                        row: rowNumber,
                        errors: rowErrors
                    });
                } else {
                    cleanedData.push({
                        city: city,
                        state: state,
                        vehicle_cap: "AIR_COURIER",
                        rate_cmt: parseFloat(freight_rate),
                        freight_type: freight_type_normalized == "PER CMT" ? 1 : freight_type_normalized == "PER TRIP" ? 3 : 0,
                        // Saved with the transporter list's own casing, not whatever
                        // case the upload happened to use - see findTransporterByName.
                        transporter_name: matchedTransporter.transporter_name,
                        transporter_code: matchedTransporter.transporter_code
                    });
                }
            });
        }


        if (cleanedData.length == 0 && errorList.length == 0) {
            errorList.push({
                row: "",
                errors: ["No Data found. All rows are empty"]
            });
        }

        this.setState({
            errors: errorList,
            validData: cleanedData
        })


        console.log("Valid Data:", cleanedData);
        console.log("Errors:", errorList);
    };

    getShortFileName = (name, maxLength = 31) => {
        const lastDot = name.lastIndexOf(".");
        const baseName = name.substring(0, lastDot);

        const extension = name.substring(lastDot);

        if (baseName.length <= maxLength) return name;

        return baseName.substring(0, maxLength) + "..." + extension;
    };

    // Case-insensitive on purpose - the uploaded sheet's TRANSPORTER NAME column
    // doesn't reliably match lmtransporters' stored casing (some are uppercase,
    // some lowercase, some mixed), so matching by exact `==` was rejecting rows
    // for transporters that actually exist. Returns the matched record itself
    // (not just a boolean) so callers can save the transporter_code/transporter_name
    // exactly as stored in the transporter list, instead of whatever case the
    // upload happened to use.
    findTransporterByName = (transporter_name) => {
        var target = String(transporter_name || '').trim().toLowerCase();
        return this.state.transporterList.find((each) => String(each.transporter_name || '').trim().toLowerCase() === target);
    }

    checkTransporterIdentity = (transporter_name) => {
        return !!this.findTransporterByName(transporter_name);
    }
    handleBulkUpload = async () => {
        this.setState({
            loadshow: 'show-m',
            overly: 'show-m',
        })
        if (this.state.actTab == 1) {
            const correctedData = this.state.validData.map((each) => {
                return ({
                    ...each,
                    loading_port_code: this.state.loading_port_code,
                    comp_short_name: this.state.lpNames.find((each) => each.loading_port_code == this.state.loading_port_code).loading_port,
                    status: 1,
                    freight_model: each.freight_model.replace(" ", "_"),
                    freight_type: each.freight_model == "PER CMT" ? 1 : each.freight_model == "PER TRIP" ? 3 : 0
                })
            })
            await this.updateFreightTypeConfig(correctedData)
            //    console.log(this.state.validData, correctedData)
        } else if (this.state.actTab == 2) {
            const correctedData = this.state.validData.map((each) => {
                return ({
                    ...each,
                    is_active: 1,
                    status: 1, loading_port_code: this.state.loading_port_code
                })
            })
            await this.updateLmStates(correctedData)
        } else if (this.state.actTab == 3) {
            const correctedData = this.state.validData.map((each) => {
                return ({
                    ...each,
                    is_active: 1,
                    status: 1, loading_port_code: this.state.loading_port_code
                })
            })

            await this.updateLmCourirerFreight(correctedData)
        } else if (this.state.actTab == 4) {
            const correctedData = this.state.validData.map((each) => {
                return ({
                    ...each,
                    is_active: 1,
                    status: 1, loading_port_code: this.state.loading_port_code
                })
            })
            await this.updateLmClubbingCharges(correctedData)
        } else if (this.state.actTab == 5) {
            const correctedData = this.state.validData.map((each) => {
                return ({
                    ...each,
                    is_active: 1,
                    status: 1, loading_port_code: this.state.loading_port_code
                })
            })

            await this.updateLmAirCourirerFreight(correctedData)
        }
        this.setState({
            // loadshow: 'show-n',
            // overly: 'show-n',
            bulkslide: false,
            errors: [],
            validData: [],
            fileName: ""
        })
    }
    render() {
        var showActions = false;
        var showDelete = true;
        if (this.state.pageAccess == 2) {
            var showActions = true;
        }
        if (this.state.pageAccess == 3) {
            var showDelete = false;
        }

        // ag-Grid's React wrapper rebuilds its whole column model whenever
        // the columnDefs array reference changes, even when the actual
        // column definitions are identical — this used to be a brand-new
        // array on every single render (any setState anywhere in this
        // component), forcing that rebuild constantly. Tab switching fires
        // several closely-spaced setState calls in a row (the tab click
        // itself, then each async data-load response), and stacking
        // several of those rebuilds is what was tripping ag-Grid's
        // "cannot get grid to draw rows when it is in the middle of
        // drawing rows" guard. This array has no live state/props baked
        // into it (verified: the only `hide` values are static, and the
        // dynamic bits are all inside valueGetter functions that read
        // params/this.state fresh on every call), so it's safe to compute
        // once and reuse the same reference across renders.
        if (!this._columnwithDefsCache) {
        this._columnwithDefsCache = [
            {
                headerName: "",
                field: "_id",
                colId: "_id",
                width: 100,
                pinned: 'left',
                filter: false, resizable: true,
                headerCheckboxSelection: true,
                headerCheckboxSelectionFilteredOnly: true,
                checkboxSelection: true,
                cellRenderer: "actionRenderer",

            },
            {
                headerName: "City",
                field: "city",
                width: 250,
                filter: true,
                resizable: true,
                // editable: true,
                flex: 1
            },
            {
                headerName: "State",
                field: "state",
                width: 250,
                filter: true,
                resizable: true,
                // editable: true,
                // cellEditor: 'agSelectCellEditor',
                // cellEditorParams: {
                //     values: this.state.statesList,
                // },
                flex: 1
            },
            {
                headerName: "Freight Rate ( ₹ )",
                field: "rate_cmt",
                width: 200,
                filter: true,
                resizable: true,
                // editable: true,
                // cellEditor: NumericCellEditor,
                flex: 1
            },
            {
                headerName: "Freight Type",
                field: "freight_type",
                width: 200,
                filter: true,
                resizable: true,
                // editable: true,
                // cellEditor: NumericCellEditor,
                flex: 1,
                valueGetter: (params) => {
                    if (params.data.freight_type == 1) {
                        return "PER CMT"
                    } else if (params.data.freight_type == 3) {
                        return "PER TRIP"
                    }
                    return params.data.freight_type
                }
            },
            {
                headerName: "Vehicle Type",
                field: "vehicle_cap",
                width: 200,
                filter: true,
                resizable: true,
                // editable: true,
                // cellEditor: 'agSelectCellEditor',
                // cellEditorParams: {
                //     values: this.state.vehicleCap,
                // },
                flex: 1
            },
            {
                pinned: "left",
                headerName: "Update",
                field: "_id",
                width: 150,
                resizable: true,
                editable: false,
                cellRendererSelector: function (params) {
                    var rendComponent = {
                        component: 'UpdateButton'
                    };
                    return rendComponent;
                },
                // hide: showActions && false
                hide: true
            },
            {
                pinned: "left",
                headerName: "Delete",
                field: "delete",
                width: 80,
                resizable: true,
                editable: false,
                cellRenderer: function (params) {
                    return '<i class="icofont icofont-ui-delete"></i>';
                },
                // hide: showDelete && false
                hide: true
            },
            // {
            //     pinned:"left",
            //     headerName: "id",
            //     field: "id",
            //     width:100,
            //     filter: true,
            //     resizable: true,
            //     editable:false,            
            // },
        ]
        }
        var columnwithDefs = this._columnwithDefsCache;

        // No live state/props baked into this one either (the "Update"
        // column's `hide: showActions || true` always evaluates to true
        // regardless of showActions, so it's effectively constant) —
        // same compute-once caching as columnwithDefs above, for the same
        // reason (stable columnDefs reference across renders).
        if (!this._tripFreightColumnwithDefsCache) {
        this._tripFreightColumnwithDefsCache = [
            {
                headerName: "",
                field: "_id",
                colId: "_id",
                width: 100,
                pinned: 'left',
                filter: false, resizable: true,
                headerCheckboxSelection: true,
                headerCheckboxSelectionFilteredOnly: true,
                checkboxSelection: true,
                cellRenderer: "actionRenderer",

            },
            {
                headerName: "Plant",
                field: "comp_short_name",
                width: 150,
                filter: true,
                resizable: true,
                editable: false,
                flex: 1
            },
            {
                headerName: "Zone",
                field: "zone",
                width: 150,
                filter: true,
                resizable: true,
                editable: false,
                flex: 1
            },
            {
                headerName: "Freight Model",
                field: "freight_model",
                width: 150,
                filter: true,
                resizable: true,
                editable: true,
                cellEditor: 'agSelectCellEditor',
                cellEditorParams: {
                    values: ["PER_CMT", "PER_TRIP"],
                },
                valueGetter: (params) => {
                    if (params.data.freight_type == 1) {
                        return "PER CMT"
                    } else if (params.data.freight_type == 3) {
                        return "PER TRIP"
                    }
                    return params.data.freight_type
                },
                flex: 1
            },
            {
                pinned: "left",
                headerName: "Update",
                field: "_id",
                width: 150,
                resizable: true,
                editable: false,
                cellRendererSelector: function (params) {
                    var rendComponent = {
                        component: 'UpdateButton'
                    };
                    return rendComponent;
                },
                hide: showActions || true
            },
        ]
        }
        var tripFreightColumnwithDefs = this._tripFreightColumnwithDefsCache;

        // Unlike the other three arrays, this one bakes this.state.actTab
        // directly into a column's `hide` value ("Vehicle Type" column, see
        // below) rather than reading it inside a function body — so it
        // can't be cached unconditionally the same way; that would freeze
        // the column's visibility to whatever actTab was active the first
        // time this ran. Keying the cache on actTab's actual effect on
        // this array (whether it equals 5) keeps the reference stable for
        // the common case (rapid re-renders while actTab doesn't cross
        // that boundary) while still rebuilding when it does.
        const courierColumnwithDefsKey = this.state.actTab === 5;
        if (!this._courierColumnwithDefsCache || this._courierColumnwithDefsCacheKey !== courierColumnwithDefsKey) {
        this._courierColumnwithDefsCacheKey = courierColumnwithDefsKey;
        this._courierColumnwithDefsCache = [
            {
                headerName: "",
                field: "_id",
                colId: "_id",
                width: 85,
                pinned: 'left',
                filter: false, resizable: true,
                headerCheckboxSelection: true,
                headerCheckboxSelectionFilteredOnly: true,
                checkboxSelection: true,
                cellRenderer: "actionRenderer",

            },
            {
                headerName: "Transporter Name",
                field: "transporter_name",
                width: 250,
                filter: true,
                resizable: true,
                // editable: true,
                flex: 1
            },
            {
                headerName: "City",
                field: "city",
                width: 250,
                filter: true,
                resizable: true,
                // editable: true,
                flex: 1
            },
            {
                headerName: "State",
                field: "state",
                width: 250,
                filter: true,
                resizable: true,
                // editable: true,
                // cellEditor: 'agSelectCellEditor',
                // cellEditorParams: {
                //     values: this.state.statesList,
                // },
                flex: 1
            },
            {
                headerName: "Freight Rate ( ₹ )",
                field: "rate_cmt",
                width: 200,
                filter: true,
                resizable: true,
                // editable: true,
                // cellEditor: NumericCellEditor,
                flex: 1,
                valueGetter: (params) => {
                    // Number(...), not the raw value — rate_cmt reaching
                    // here as a non-numeric string (e.g. an unconverted
                    // form input) used to crash this column's whole render
                    // with ".toFixed is not a function" instead of just
                    // showing a blank/raw cell for that one row.
                    const rate = Number(params.data.rate_cmt);
                    if (params.data.rate_cmt && !isNaN(rate)) {
                        return rate.toFixed(2)
                    }
                    return params.data.rate_cmt
                }
            },
            {
                headerName: "Freight Type",
                field: "freight_type",
                width: 200,
                filter: true,
                resizable: true,
                // editable: true,
                // cellEditor: NumericCellEditor,
                flex: 1,
                valueGetter: (params) => {
                    if (params.data.freight_type == 1) {
                        return "PER CMT"
                    } else if (params.data.freight_type == 3) {
                        return "PER TRIP"
                    }
                    return params.data.freight_type
                }
            },
            {
                headerName: "Vehicle Type",
                field: "vehicle_cap",
                width: 200,
                filter: true,
                resizable: true,
                hide: this.state.actTab === 5,
                // editable: true,
                // cellEditor: 'agSelectCellEditor',
                // cellEditorParams: {
                //     values: this.state.vehicleCap,
                // },
                flex: 1
            },
            {
                pinned: "left",
                headerName: "Update",
                field: "_id",
                width: 150,
                resizable: true,
                editable: false,
                cellRendererSelector: function (params) {
                    var rendComponent = {
                        component: 'UpdateButton'
                    };
                    return rendComponent;
                },
                // hide: showActions && false
                hide: true
            },
            {
                pinned: "left",
                headerName: "Delete",
                field: "delete",
                width: 80,
                resizable: true,
                editable: false,
                cellRenderer: function (params) {
                    return '<i class="icofont icofont-ui-delete"></i>';
                },
                // hide: showDelete && false
                hide: true
            },
            // {
            //     pinned:"left",
            //     headerName: "id",
            //     field: "id",
            //     width:100,
            //     filter: true,
            //     resizable: true,
            //     editable:false,            
            // },
        ]
        }
        var courierColumnwithDefs = this._courierColumnwithDefsCache;

        // No live state/props baked into this one — same compute-once
        // caching as columnwithDefs/tripFreightColumnwithDefs above.
        if (!this._clubbingColumnwithDefsCache) {
        this._clubbingColumnwithDefsCache = [
            {
                headerName: "",
                field: "_id",
                colId: "_id",
                width: 85,
                pinned: 'left',
                filter: false, resizable: true,
                headerCheckboxSelection: true,
                headerCheckboxSelectionFilteredOnly: true,
                checkboxSelection: true,
                cellRenderer: "actionRenderer",

            },
            {
                headerName: "Vehicle Type",
                field: "vehicle_cap",
                width: 150,
                filter: true,
                resizable: true,
                // editable: true,
                flex: 1
            },
            {
                headerName: "Clubbing Type",
                field: "clubbing_type",
                width: 190,
                filter: true,
                resizable: true, hide: true,
                valueGetter: (params) => {
                    if (params.data.clubbing_type == "intra_city") {
                        return "Intra-City"
                    } else if (params.data.clubbing_type == "inter_city") {
                        return "Inter-City"
                    }
                    return params.data.freight_type
                },
                flex: 1
            },
            {
                headerName: "Intra-City Charge ( ₹ )",
                field: "intra_city_charge",
                width: 190,
                filter: true,
                resizable: true,
                valueGetter: (params) => {

                    return params.data.intra_city_charge || "0"
                },
                flex: 1
            },
            {
                headerName: "Inter-City Charge ( ₹ )",
                field: "inter_city_charge",
                width: 190,
                filter: true,
                resizable: true,
                valueGetter: (params) => {

                    return params.data.inter_city_charge || "0"
                },
                flex: 1
            },
            {
                headerName: "Load Based Penalty ( ₹ )",
                field: "load_based_penalty",
                width: 190,
                filter: true,
                resizable: true,
                valueGetter: (params) => {

                    return params.data.load_based_penalty || 0
                },
                flex: 1
            },
            {
                headerName: "Load Based Incentive ( ₹ )",
                field: "load_based_incentive",
                width: 195,
                filter: true,
                resizable: true,
                valueGetter: (params) => {

                    return params.data.load_based_incentive || 0
                },
                flex: 1
            },
            {
                headerName: "Trip Penalty ( Min CMT )",
                field: "trip_penalty_min_cmt",
                width: 190,
                filter: true,
                resizable: true,
                valueGetter: (params) => {

                    return params.data.trip_penalty_min_cmt || 0
                },
                flex: 1
            },
            {
                headerName: "Trip Incentive ( Min CMT )",
                field: "trip_incentive_min_cmt",
                width: 195,
                filter: true,
                resizable: true,
                valueGetter: (params) => {

                    return params.data.trip_incentive_min_cmt || 0
                },
                flex: 1
            }
        ]
        }
        var clubbingColumnwithDefs = this._clubbingColumnwithDefsCache;

        var errTrueUpload = this.state.errors.length > 0 && this.state.validData.length > 0
        var disableUpload = this.state.validData.length == 0
        const courierOptionAllowed = ["GUR", "MANE", "RPDCGUR", "GUR-2"];
        var columnObject = { 1: tripFreightColumnwithDefs, 2: columnwithDefs, 3: courierColumnwithDefs, 4: clubbingColumnwithDefs, 5: courierColumnwithDefs }
        var rowObject = { 1: this.state.tripFreightrowData, 2: this.state.rowData, 3: this.state.courierData, 4: this.state.clubbingChargesData, 5: this.state.airCourierData }
        var columnDefs = columnObject[this.state.actTab]
        var rowData = rowObject[this.state.actTab]
        const onExportClick = () => {
            if (this.gridRef.current && this.gridRef.current.api) {
                // this.gridRef.current.api.exportDataAsCsv();
                this.gridRef.current.api.exportDataAsExcel({
                    fileName: "freight.xlsx"
                });
            }
        };
        return (
            <div class="container-fluid" style={{height: "100%"}}>
                <SweetAlert
                    show={this.state.show}
                    type={this.state.basicType}
                    title={this.state.basicTitle}
                    onConfirm={this.closeAlert}
                >
                </SweetAlert>


                <div className="row" style={{ marginBottom: "10px" }}>

                    <div className="col-sm-12">

                        <ul
                            style={{
                                display: "inline-flex",
                                flexWrap: "wrap",      // 🔥 prevents cutting
                                padding: "4px",
                                margin: 0,
                                listStyle: "none",
                                gap: "4px",
                                backgroundColor: "#ffffff",
                                borderRadius: "10px",
                                boxShadow: "0 1px 3px rgba(0,0,0,0.15)"
                            }}
                        >

                            {[
                                { tab: 1, label: "Config" },
                                { tab: 2, label: "Freights" },
                                { tab: 3, label: "Surface Courier" },
                                { tab: 5, label: "Air Courier" },
                                { tab: 4, label: "Clubbing Charges" },
                            ].map(({ tab, label }) => {
                                var isActive = this.state.actTab == tab;
                                return (
                                    <li key={tab} onClick={() => this.onClickTab(tab)} style={{ listStyle: "none" }}>
                                        <button
                                            type="button"
                                            style={{
                                                whiteSpace: "nowrap",
                                                border: "none",
                                                outline: "none",
                                                borderRadius: "999px",
                                                padding: "8px 18px",
                                                fontSize: "13px",
                                                fontWeight: isActive ? 600 : 500,
                                                cursor: "pointer",
                                                transition: "all 0.2s ease",
                                                backgroundColor: isActive ? "#1976d2" : "transparent",
                                                color: isActive ? "#fff" : "#555",
                                                boxShadow: isActive ? "0 1px 4px rgba(25,118,210,0.4)" : "none"
                                            }}
                                        >
                                            {label}
                                        </button>
                                    </li>
                                );
                            })}

                        </ul>

                    </div>
                </div>

                <div className="card col-xl-12 d-flex flex-column" style={{height: "90%", borderRadius: "10px", boxShadow: "0 1px 4px rgba(0,0,0,0.08)"}}>
                    <div className="d-flex justify-content-between align-items-center" style={{flexWrap: "wrap", gap: "10px", padding: "14px 18px", marginBottom: "10px", flexShrink: 0}}>
                        <div className="d-flex align-items-center" style={{gap: "14px"}}>
                            <div style={{ width: "5px", height: "26px", background: "linear-gradient(180deg,#1976d2,#42a5f5)", borderRadius: "3px", flexShrink: 0 }}></div>
                            <h5 style={{margin: 0, fontSize: "16px", fontWeight: 700, color: "#1a237e", letterSpacing: "0.2px"}}>Freights</h5>
                        </div>
                        <div className="d-flex align-items-center" style={{flexWrap: "wrap", gap: "8px"}}>
                            {(this.state.selectedRows.length > 0 && this.state.pageAccess != 2) && <button
                                className="pill-btn pill-btn-danger"
                                onClick={() => {
                                    this.handleBulkDelete(this.state.selectedRows.map((each) => each._id) || [])
                                }}
                                disabled={this.state.selectedRows.length == 0}
                            >
                                Delete Selected
                            </button>}
                            <button className="pill-btn pill-btn-primary" onClick={this.onClickDataExport.bind(this)}>Export Data</button>
                            {(this.state.pageAccess != 2) ?
                                <button className="pill-btn pill-btn-info" onClick={this.showBulkUpload.bind(this)}>Import Data</button>
                                : ""}
                            {(this.state.pageAccess != 2) ?
                                <button className="pill-btn pill-btn-success" onClick={this.addNewRow.bind(this)}>+ Add</button>
                                : ""}
                            {(this.state.pageAccess == 3) ?
                                <button className="btn btn-danger d-none" onClick={this.onClickBulkDelete.bind(this)}>Delete</button>
                                : ""}
                            <button className="btn btn-info d-none" onClick={this.onClickGetTripFreightConfig.bind(this)}>Config</button>
                        </div>
                    </div>
                    {/* <div className="col-xl-12 col-lg-12 flex-grow-1 bg-primary"></div> */}
                    
                    <div className="col-xl-12 col-lg-12" style={{ flex: "1 1 0%", minHeight: 0, width: "100%", display: "flex", flexDirection: "column" }}>
                        <div className="row d-none" style={{ marginBottom: "2%" }}>
                            <div className="col-xl-2 col-lg-2" style={{ paddingRight: 0 }}>
                                <label style={{ marginTop: "4%" }}>Set Freight Rate</label>
                            </div>
                            <div className="col-xl-2 col-lg-2" style={{ padding: 0 }}>
                                <select class="form-control" id="freightType" onChange={this.onChangeFreightType.bind(this)}>
                                    <option selected={(this.state.freight_type == 1) ? "selected" : ""} value="1">Per CMT</option>
                                    {/* <option selected={(this.state.freight_type == 2) ? "selected" : ""} value="2">Per KM</option> */}
                                    {courierOptionAllowed.includes(this.state.loading_port_code) ? <option selected={(this.state.freight_type == 3) ? "selected" : ""} value="3">Per TRIP</option>
                                        : ''}
                                </select>
                            </div>
                        </div>
                        {/* <div id="myGrid" style={{ width: "100%", height: "478px" }} className={"ag-theme-balham d-none" + this.state.showGridData}>
                            {this.state.actTab == 2 ? <AgGridReact
                                modules={this.state.modules}
                                columnDefs={columnwithDefs}
                                defaultColDef={this.state.defaultColDef}
                                rowData={this.state.rowData}
                                enableCharts={false}
                                // autoGroupColumnDef={this.state.autoGroupColumnDef}
                                onGridReady={this.onGridReady}
                                onGridState={this.onGridState}
                                frameworkComponents={this.state.frameworkComponents}
                                statusBar={this.state.statusBar}
                                sideBar={this.state.sideBar}
                                stopEditingWhenGridLosesFocus={true}
                                paginationPageSize={this.state.paginationPageSize}
                                pagination={true}
                                gridOptions={{
                                    context: { componentParent: this }
                                }}
                                // components={this.state.components}
                                enableRangeSelection={true}
                                // onCellClicked={this.onCellClicked}
                                // rowSelection={this.state.rowSelection}
                                onRowSelected={this.onRowSelection.bind(this)}
                            // onCellEditingStopped={this.onCellUpdateData.bind(this)}
                            /> : this.state.actTab == 1 ?
                                <AgGridReact
                                    modules={this.state.modules}
                                    columnDefs={tripFreightColumnwithDefs}
                                    defaultColDef={this.state.defaultColDef}
                                    rowData={this.state.tripFreightrowData}
                                    enableCharts={false}
                                    // autoGroupColumnDef={this.state.autoGroupColumnDef}
                                    onGridReady={this.onGridReadyTripFreight}
                                    onGridState={this.onGridStateTripFreight}
                                    frameworkComponents={this.state.frameworkComponents}
                                    statusBar={this.state.statusBar}
                                    sideBar={this.state.sideBar}
                                    paginationPageSize={this.state.paginationPageSize}
                                    pagination={true}
                                    gridOptions={{
                                        context: { componentParent: this }
                                    }}
                                /> : this.state.actTab == 3 ?
                                    <AgGridReact
                                        modules={this.state.modules}
                                        columnDefs={courierColumnwithDefs}
                                        defaultColDef={this.state.defaultColDef}
                                        rowData={this.state.courierData}
                                        enableCharts={false}
                                        // autoGroupColumnDef={this.state.autoGroupColumnDef}
                                        onGridReady={this.onGridReadyTripFreight}
                                        onGridState={this.onGridStateTripFreight}
                                        frameworkComponents={this.state.frameworkComponents}
                                        statusBar={this.state.statusBar}
                                        sideBar={this.state.sideBar}
                                        paginationPageSize={this.state.paginationPageSize}
                                        pagination={true}
                                        gridOptions={{
                                            context: { componentParent: this }
                                        }}
                                    /> : this.state.actTab == 4 ?
                                        <AgGridReact
                                            modules={this.state.modules}
                                            columnDefs={clubbingColumnwithDefs}
                                            defaultColDef={this.state.defaultColDef}
                                            rowData={this.state.clubbingChargesData}
                                            enableCharts={false}
                                            // autoGroupColumnDef={this.state.autoGroupColumnDef}
                                            onGridReady={this.onGridReadyTripFreight}
                                            onGridState={this.onGridStateTripFreight}
                                            frameworkComponents={this.state.frameworkComponents}
                                            statusBar={this.state.statusBar}
                                            sideBar={this.state.sideBar}
                                            paginationPageSize={this.state.paginationPageSize}
                                            pagination={true}
                                            gridOptions={{
                                                context: { componentParent: this }
                                            }}
                                        /> : ""}
                        </div> */}

                        <div className="ag-theme-balham grid-wrapper" style={{flex: 1, minHeight: 0, marginBottom: "15px"}}>
                            <AgGridReact
                                ref={this.gridRef}
                                modules={this.state.modules}
                                rowData={rowData}
                                columnDefs={columnDefs}
                                defaultColDef={{
                                    sortable: true,
                                    filter: true,
                                    floatingFilter: true
                                }}

                                statusBar={{
                                    statusPanels: [
                                        { statusPanel: "agSelectedRowCountComponent", align: "left" },
                                        { statusPanel: "agFilteredRowCountComponent", align: "center" },
                                        { statusPanel: "agTotalRowCountComponent", align: "right" }
                                    ]
                                }}
                                sideBar={{
                                    toolPanels: [
                                        {
                                            id: 'columns',
                                            labelDefault: 'Columns',
                                            iconKey: 'columns',
                                            toolPanel: 'agColumnsToolPanel'
                                        },
                                        {
                                            id: 'filters',
                                            labelDefault: 'Filters',
                                            iconKey: 'filter',
                                            toolPanel: 'agFiltersToolPanel'
                                        }
                                    ],
                                    // defaultToolPanel: 'filters'
                                }}
                                animateRows rowSelection={"multiple"}
                                rowHeight={45}
                                headerHeight={45}
                                frameworkComponents={this.state.frameworkComponents}
                                onSelectionChanged={() => {
                                    // deferred: ag-Grid fires this mid-render when rowData/columnDefs
                                    // change (tab switch), and setState here rebuilds those props
                                    // synchronously, causing a reentrant grid redraw
                                    setTimeout(() => {
                                        if (this.gridRef && this.gridRef.current && this.gridRef.current.api) {
                                            const selected = this.gridRef.current.api.getSelectedRows();
                                            this.setState({ selectedRows: selected })
                                        }
                                    }, 0);
                                }} suppressRowClickSelection={true}
                            />
                        </div>
                    </div>
                </div>


                {/* <button className="btn btn-success" onClick={this.formAssignHandler.bind(this)} style={{marginLeft:"91em"}}>Insert Exports</button> */}
                <div className={"slide-r d-none" + (this.state.bulkslide)} style={{ overflow: "hidden" }}>
                    <h3 className="subH">Bulk Upload</h3>
                    <div className="slide-r-body" style={{ position: "relative" }}>

                        <div className="container-fluid">
                            <form method="POST" id="upform" className="theme-form" onSubmit={this.uploadBulkFormHandler}>

                                <div className="form-group mt-20p">
                                    <label className="">Upload File</label>
                                    <input type="file" name="uploadFile" id="bulkUploadID" onChange={this.changeFileHandler} className="form-control" required />
                                </div>
                                <div className="form-group">
                                    <button type="submit" className="btn btn-success">Submit</button>
                                    <button type="button" onClick={this.resetUpload.bind(this)} className="btn btn-default">Cancel</button>
                                </div>
                            </form>
                            <div className="form-group">
                                <a className="btn btn-primary" href={require('../../assets/json/sample_lmfreights_general.csv')} target="_blank">Sample Template</a>
                            </div>
                        </div>
                    </div>
                </div>
                <div className={`hub-slider ${this.state.bulkslide ? "open" : ""} d-flex flex-column`}>

                    <div className="slider-header">
                        Import Data
                        <span onClick={this.onClickHideAll.bind(this)} style={{ cursor: "pointer" }}>✕</span>
                    </div>

                    <div className="slider-body flex-grow-1 d-flex flex-column" style={{ minHeight: "0px" }}>

                        <input
                            ref={this.fileInputRef}
                            type="file"
                            accept=".xlsx,.xls,.csv"
                            onChange={this.handleFileChange}
                            style={{ display: "none" }}
                        />
                        {/* Upload button */}
                        <div className="d-flex align-items-center gap-3">
                            <button
                                className="btn btn-info d-flex justify-content-center p-3"
                                type="button"
                                onClick={() => this.fileInputRef.current.click()}
                            >
                                Upload File
                            </button>

                            <a href={
                                this.state.actTab == 1 ? require("../../assets/freightconfig.xlsx")
                                    : this.state.actTab == 2 ? require("../../assets/freight.xlsx")
                                        : this.state.actTab == 3 ? require("../../assets/courierfreight.xlsx")
                                            : this.state.actTab == 4 ? require("../../assets/clubbingcharges.xlsx")
                                                : this.state.actTab == 5 ? require("../../assets/courierfreight.xlsx") : ""
                            } className="btn btn-secondary d-flex justify-content-center ml-3 p-3 flex-grow-1">
                                Download Sample Template
                            </a>
                        </div>

                        {this.state.fileName && (
                            <div style={{ marginTop: "15px", display: "flex", gap: "6px", maxWidth: "410px" }}>
                                <span>Selected File :</span>
                                <span
                                    style={{
                                        whiteSpace: "nowrap",
                                        overflow: "hidden",
                                        textOverflow: "ellipsis",
                                        flex: 1,
                                        fontWeight: "bold"
                                    }}
                                    title={this.state.fileName}
                                >
                                    {this.getShortFileName(this.state.fileName)}
                                </span>
                            </div>
                        )}


                        {this.state.errors.length > 0 && (
                            <>
                                <h6 className="text-danger mt-3">Validation Errors</h6>

                                <div style={{ flexGrow: 1, overflowY: "auto", width: "100%" }}>
                                    <table className="table-bordered mb-0 err-table" style={{ width: "100%", positive: "relative" }}>
                                        <thead className="table-light text-center" style={{ positive: "sticky", zIndex: "100", backgroundColor: "#efefef" }}>
                                            <tr>
                                                <th style={{ width: "60px", padding: "9px 15px" }}>Row</th>
                                                <th>Error Description</th>
                                            </tr>
                                        </thead>

                                        <tbody>
                                            {this.state.errors.map((err, i) => (
                                                <tr key={i}>
                                                    <td className="text-center" style={{ padding: "9px 15px" }}>
                                                        {err.row}
                                                    </td>

                                                    <td style={{ padding: "9px 15px", wordBreak: "break-word" }}>
                                                        {err.errors.map((e, idx) => (
                                                            <p className="m-0" key={idx}>{e}</p>
                                                        ))}
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            </>
                        )}

                    </div>
                    <div className="slider-footer">
                        <button
                            className="save-btn" style={{ margin: "0px", width: "auto", padding: "5px 25px", cursor: disableUpload && "not-allowed", opacity: disableUpload && "0.5" }}
                            onClick={this.handleBulkUpload}
                            disabled={disableUpload}
                        >
                            {errTrueUpload ? "Submit only valid data" : "Submit"}
                        </button>
                    </div>

                </div>


                {this.state.tripFreightrowData.length ?
                    <div className={"slide-r d-none" + (this.state.bulkslide)} style={{ overflow: "hidden" }}>
                        <h3 className="subH">Trip Freight Configuration</h3>
                        <div className="slide-r-body" style={{ position: "relative" }}>

                            <div id="tripFreightGrid" style={{ width: "100%", height: "478px" }} className={"ag-theme-balham " + this.state.showGridData}>
                                <AgGridReact
                                    modules={this.state.modules}
                                    columnDefs={tripFreightColumnwithDefs}
                                    defaultColDef={this.state.defaultColDef}
                                    rowData={this.state.tripFreightrowData}
                                    rowHeight={45}
                                    headerHeight={45}
                                    enableCharts={false}
                                    // autoGroupColumnDef={this.state.autoGroupColumnDef}
                                    onGridReady={this.onGridReadyTripFreight}
                                    onGridState={this.onGridStateTripFreight}
                                    frameworkComponents={this.state.frameworkComponents}
                                    statusBar={this.state.statusBar}
                                    sideBar={this.state.sideBar}
                                    paginationPageSize={this.state.paginationPageSize}
                                    pagination={true}
                                    gridOptions={{
                                        context: { componentParent: this }
                                    }}
                                />
                            </div>
                        </div>
                    </div>
                    : ''}
                {this.state.controller.open && (
                    <>
                        <div
                            className="slider-overlay"
                            onClick={this.onClickHideAll.bind(this)}
                        />
                        <AddEditController
                            resource={this.state.controller}
                            onUpdate={this.onUpdateFreight}
                            closeSlider={this.onClickHideAll.bind(this)}
                        />
                    </>
                )}

                <div className={"dataLoadpage " + (this.state.loadshow)}>
                </div>
                <div className={"dataLoadpageimg " + (this.state.loadshow)}>
                    <div className="loader-box"><div className="loader-box"><div className="rotate dashed colored"></div></div></div>
                </div>
                <div className={"overlay-part " + (this.state.overly)} onClick={this.onClickHideAll.bind(this)}></div>
            </div>

        );
    }
}

function dateComparator1(date1, date2) {
    //console.log(date1,date2);
    if (date1 != "" && date2 != "" && date1 != undefined && date2 != undefined) {
        // console.log(date1,date2);
        var date_1 = getMonthNumber(date1.split("-")[1]);
        date1 = date1.replace(date1.split("-")[1], date_1);
        var date_2 = getMonthNumber(date2.split("-")[1]);
        date2 = date2.replace(date2.split("-")[1], date_2);
        var date1Number = monthToComparableNumber1(date1);
        var date2Number = monthToComparableNumber1(date2);
        if (date1Number === null && date2Number === null) {
            return 0;
        }
        if (date1Number === null) {
            return -1;
        }
        if (date2Number === null) {
            return 1;
        }
        return date1Number - date2Number;
    }
}

function monthToComparableNumber1(date) {
    console.log(date.length);
    console.log(date);
    if (date === undefined || date === null || date.length !== 10) {
        return null;
    }
    var yearNumber = date.substring(6, 10);
    var monthNumber = date.substring(3, 5);
    var dayNumber = date.substring(0, 2);
    var result = yearNumber * 10000 + monthNumber * 100 + dayNumber;
    return result;
}
function dateComparator(date1, date2) {
    // console.log("dateComparator");
    // console.log(date1.length);
    if (date1 != "" && date2 != "" && date1 != undefined && date2 != undefined) {
        // console.log(date1,date2);
        var date_1 = getMonthNumber(date1.split(" ")[0].split("-")[1]);
        date1 = date1.replace(date1.split(" ")[0].split("-")[1], date_1);
        var date_2 = getMonthNumber(date2.split(" ")[0].split("-")[1]);
        date2 = date2.replace(date2.split(" ")[0].split("-")[1], date_2);
        // console.log(date1,date2);
        var date1Number = monthToComparableNumber(date1);
        var date2Number = monthToComparableNumber(date2);
        // console.log(date1Number,date2Number);
        if (date1Number === null && date2Number === null) {
            return 0;
        }
        if (date1Number === null) {
            return -1;
        }
        if (date2Number === null) {
            return 1;
        }
        return date1Number - date2Number;
    }
}
function monthToComparableNumber(date) {
    // console.log(date,date.length);
    if (date === undefined || date === null || date.length !== 16) {
        return null;
    }
    var yearNumber = date.substring(6, 10);
    var monthNumber = date.substring(3, 5);
    var dayNumber = date.substring(0, 2);
    console.log(yearNumber, monthNumber, dayNumber);
    var result = yearNumber * 10000 + monthNumber * 100 + dayNumber;
    return result;
}

function getMonthNumber(monthName) {
    var months = [
        'Jan', 'Feb', 'Mar', 'Apr', 'May',
        'Jun', 'Jul', 'Aug', 'Sep',
        'Oct', 'Nov', 'Dec'
    ];
    var monthNum = months.indexOf(monthName) + 1;
    if (monthNum < 10) {
        monthNum = "0" + monthNum.toString();
    }
    return monthNum;
}


function loadDateTimeScript() {
    // alert("timeDate");
    $('.datetimepicker_mask').datetimepicker({
        //mask:'39-19-9999 29:59',
        format: 'd-m-Y'
    });
    $('.datetimepicker_date').datetimepicker({
        mask: '39-19-9999',
        format: 'd-m-Y',
        timepicker: false
    });
    var index = window.document.getElementsByTagName("script")[1]
    var script = window.document.createElement("script")
    script.src = "https://www.jqueryscript.net/demo/Clean-jQuery-Date-Time-Picker-Plugin-datetimepicker/jquery.datetimepicker.js"
    //script.src="http://xdsoft.net/jqplugins/datetimepicker/"
    script.async = true
    script.defer = true
    index.parentNode.insertBefore(script, index)
}

function DateEditor() { }

// gets called once before the renderer is used
DateEditor.prototype.init = function (params) {
    // create the cell
    this.eInput = document.createElement('input');
    this.eInput.value = params.value;

    // https://jqueryui.com/datepicker/
    $(this.eInput).datetimepicker({
        dateFormat: "yy-mm-dd",
        changeMonth: true,
        changeYear: true,
        timepicker: false,
    });
};

// gets called once when grid ready to insert the element
DateEditor.prototype.getGui = function () {
    return this.eInput;
};

// focus and select can be done after the gui is attached
DateEditor.prototype.afterGuiAttached = function () {
    this.eInput.focus();
    this.eInput.select();
};

// returns the new value after editing
DateEditor.prototype.getValue = function () {
    // console.log(this.eInput.value);
    return this.eInput.value;
};

// any cleanup we need to be done here
DateEditor.prototype.destroy = function () {
    // but this example is simple, no cleanup, we could
    // even leave this method out as it's optional
};

// if true, then this editor will appear in a popup
DateEditor.prototype.isPopup = function () {
    // and we could leave this method out also, false is the default
    return false;
};

function NumericCellEditor() {
}

// gets called once before the renderer is used
NumericCellEditor.prototype.init = function (params) {
    // create the cell
    this.eInput = document.createElement('input');

    if (isCharNumeric(params.charPress)) {
        this.eInput.value = params.charPress;
    } else {
        if (params.value !== undefined && params.value !== null) {
            this.eInput.value = params.value;
        }
    }

    var that = this;
    this.eInput.addEventListener('keypress', function (event) {
        if (!isKeyPressedNumeric(event)) {
            that.eInput.focus();
            if (event.preventDefault) event.preventDefault();
        } else if (that.isKeyPressedNavigation(event)) {
            event.stopPropagation();
        }
    });

    // only start edit if key pressed is a number, not a letter
    var charPressIsNotANumber = params.charPress && ('1234567890'.indexOf(params.charPress) < 0);
    this.cancelBeforeStart = charPressIsNotANumber;
};

function getCharCodeFromEvent(event) {
    event = event || window.event;
    return (typeof event.which == "undefined") ? event.keyCode : event.which;
}

function isCharNumeric(charStr) {
    return !!/\d/.test(charStr);
}

function isCharDecimal(charStr) {
    return !!/\./.test(charStr);
}

function isKeyPressedNumeric(event) {
    const charCode = getCharCodeFromEvent(event);
    const charStr = String.fromCharCode(charCode);
    return isCharNumeric(charStr) || isCharDecimal(charStr);
}

NumericCellEditor.prototype.isKeyPressedNavigation = function (event) {
    return event.keyCode === 39
        || event.keyCode === 37;
};


// gets called once when grid ready to insert the element
NumericCellEditor.prototype.getGui = function () {
    return this.eInput;
};

// focus and select can be done after the gui is attached
NumericCellEditor.prototype.afterGuiAttached = function () {
    this.eInput.focus();
};

// returns the new value after editing
NumericCellEditor.prototype.isCancelBeforeStart = function () {
    return this.cancelBeforeStart;
};

// example - will reject the number if it contains the value 007
// - not very practical, but demonstrates the method.
NumericCellEditor.prototype.isCancelAfterEnd = function () {
    var value = this.getValue();
    return value.indexOf('007') >= 0;
};

// returns the new value after editing
NumericCellEditor.prototype.getValue = function () {
    return this.eInput.value;
};

// any cleanup we need to be done here
NumericCellEditor.prototype.destroy = function () {
    // but this example is simple, no cleanup, we could  even leave this method out as it's optional
};

// if true, then this editor will appear in a popup 
NumericCellEditor.prototype.isPopup = function () {
    // and we could leave this method out also, false is the default
    return false;
};

function isValidState(uploadedData, availableData) {

    if (availableData.includes(uploadedData.toUpperCase())) {
        return true;
    } else {
        return false;
    }
}

// freights

//    Add new tab Clubbing Charges (collection_name: lmclubbingfreights)

//      vehicle type (hub_vehicle --> 0)
//      intra-city
//      inter-city


// share of business

//   Add new hub tab in approved sob percentage

//   in aggrid in place of zone add hubs and follow the same process what they are following now.

// Add new hub tab in actual sob percentage

//   in aggrid in place of zone add hubs and follow the same process what they are following now.


// transporters

//   add hub tab

//    map to hub instead of zone (hub_vehicle: 1)

// lmloadshare



